<template>
  <v-container :key="mdmUp" fluid style="padding:0" v-if="showWorksheet" >
    <v-form :disabled="readonly" ref="mdmform" v-model="mdmValidInt">
        <v-row no-gutters class="pb-0" style="height:50px;">
            <v-col cols="3" style="height:50px;" :class="'text-center ' + (proMode ? 'checkBoxBorderedDK' : 'checkBoxBorderedLT')">
                <v-checkbox @change="calculateMDM" 
                    style="margin:7px 5px;"
                    class="nextDay"
                    v-model="mdmVal.worksheet.general.shared_visit"
                    :label="(qaEnc && mdmQaVal ? 'Shared: ' + mdmQaVal.worksheet.general.shared_visit + (mdmQaVal.worksheet.general.shared_visit == mdmVal.worksheet.general.shared_visit ? ' - ✓' : ' - ✗' ) : 'Shared Visit')"
                >
                    <template v-slot:append>
                        <v-tooltip max-width="350px" bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-icon
                                    color="primary"
                                    :dark="proMode"
                                    v-bind="attrs"
                                    v-on="on"
                                >
                                    mdi-information-outline
                                </v-icon>
                            </template>
                            <span>{{worksheetsettings.labels && worksheetsettings.labels.general.shared_visit}}</span>
                        </v-tooltip>
                    </template>
                </v-checkbox>
            </v-col>
            <v-col cols="3" style="height:50px;" :class="'text-center ' + (proMode ? 'checkBoxBorderedDK' : 'checkBoxBorderedLT')">
                <v-checkbox @change="calculateMDM" 
                    style="margin:7px 5px;"
                    class="nextDay"
                    v-model="mdmVal.worksheet.general.teaching"
                    :label="(qaEnc && mdmQaVal ? 'Teaching: ' + mdmQaVal.worksheet.general.teaching + (mdmQaVal.worksheet.general.teaching == mdmVal.worksheet.general.teaching ? ' - ✓' : ' - ✗' ) : 'Teaching')"
                >
                    <template v-slot:append>
                        <v-tooltip max-width="350px" bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-icon
                                    color="primary"
                                    :dark="proMode"
                                    v-bind="attrs"
                                    v-on="on"
                                >
                                    mdi-information-outline
                                </v-icon>
                            </template>
                            <span>{{worksheetsettings.labels && worksheetsettings.labels.general.teaching}}</span>
                        </v-tooltip>
                    </template>
                </v-checkbox>
            </v-col>
            <v-col cols="6">
                <v-select
                    class="demofields tallField"
                    dense
                    outlined
                    v-model="mdmVal.worksheet.general.time"
                    :items="emToolProLT.time"
                    :label="(qaEnc && mdmQaVal && mdmQaVal.worksheet.general.time ? 'Time: ' + mdmQaVal.worksheet.general.time + (mdmQaVal.worksheet.general.time == mdmVal.worksheet.general.time ? ' - ✓' : ' - ✗' ) : 'Time')"
                    :class="(qaEnc ? 'activeLabelOver' : '')"
                    @input="calculateMDM"
                ></v-select>
            </v-col>
        </v-row>
        <v-row no-gutters class="pb-2" style="height:60px;">
            <v-col cols="6">
                <v-autocomplete
                    class="demofields tallField"
                    dense
                    :label="(qaEnc && mdmQaVal.em[0] ? 'BP: ' + getProviderDetail(mdmQaVal.em[0].billing_provider) + (mdmQaVal.em[0].billing_provider == mdmVal.em[0].billing_provider ? ' - ✓' : ' - ✗' ) : 'Billing Provider')"
                    :class="(qaEnc ? 'activeLabelOver' : '')"
                    :rules="fieldRuleDep(mdmVal.em[0].billing_provider,'billing_provider',mdmVal.em[0].code)"
                    v-model="mdmVal.em[0].billing_provider"
                    outlined
                    item-text="displayName"
                    item-value="clientid"
                    :items=$store.getters.Providers
                ></v-autocomplete>
            </v-col>
            <v-col cols="6">
                <v-autocomplete
                    class="demofields tallField"
                    dense
                    :label="(qaEnc && mdmQaVal.em[0] ? 'SP: ' + getProviderDetail(mdmQaVal.em[0].secondary_provider) + (mdmQaVal.em[0].secondary_provider == mdmVal.em[0].secondary_provider ? ' - ✓' : ' - ✗' ) : 'Secondary Provider')"
                    :class="(qaEnc ? 'activeLabelOver' : '')"
                    :rules="fieldRuleDep(mdmVal.em[0].secondary_provider,'secondary_provider',mdmVal.em[0].code)"
                    v-model="mdmVal.em[0].secondary_provider"
                    outlined
                    item-text="displayName"
                    item-value="clientid"
                    :items=$store.getters.Providers
                ></v-autocomplete>
            </v-col>
        </v-row>
        <v-row>
            <v-expansion-panels 
                :style="'border:solid 1px ' + (proMode ? 'rgba(255, 255, 255, 0.12)':'rgba(0, 0, 0, 0.12)')"
                :dark="proMode" 
                v-model="proworksheetexp" 
                multiple 
                accordion
                tile
            >
                <v-expansion-panel
                    key="history"
                >
                    <v-expansion-panel-header class="py-0" :color = "(proMode ? 'rgba(255, 255, 255, 0.08)':'rgba(0, 0, 0, 0.08)')" :style="'border-bottom:solid 1px ' + (proMode ? 'rgba(255, 255, 255, 0.12)':'rgba(0, 0, 0, 0.12)')">
                        History {{(emToolPro.history ? " - " + emToolPro.history : "")}}
                    </v-expansion-panel-header>
                    <v-expansion-panel-content class="px-2 mx-0 py-2">
                        <v-row no-gutters class="pb-2">
                            <v-col cols="12">
                                <v-row no-gutters class="pb-0">
                                    <v-col cols="12" :class="'text-center text-h6 ' + (proMode ? 'checkBoxBorderedDK' : 'checkBoxBorderedLT')">
                                        History of Present Illness (HPI)
                                        <v-tooltip max-width="350px" bottom v-if="worksheetsettings.labels && worksheetsettings.labels.history.hpi.header">
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-icon
                                                    color="primary"
                                                    :dark="proMode"
                                                    v-bind="attrs"
                                                    v-on="on"
                                                >
                                                    mdi-information-outline
                                                </v-icon>
                                            </template>
                                            <span>{{worksheetsettings.labels.history.hpi.header}}</span>
                                        </v-tooltip>
                                    </v-col>
                                </v-row>
                                <v-row no-gutters class="pb-0" style="height:50px;">
                                    <v-col cols="3" style="height:50px;" :class="'text-center ' + (proMode ? 'checkBoxBorderedDK' : 'checkBoxBorderedLT')">
                                        <v-checkbox @change="calculateMDM" 
                                            style="margin:7px 5px;"
                                            class="nextDay"
                                            v-model="mdmVal.worksheet.history.hpi.location"
                                            :label="(qaEnc && mdmQaVal ? 'Location: ' + mdmQaVal.worksheet.history.hpi.location + (mdmQaVal.worksheet.history.hpi.location == mdmVal.worksheet.history.hpi.location ? ' - ✓' : ' - ✗' ) : 'Location')"
                                        >
                                            <template v-slot:append>
                                                <v-tooltip max-width="350px" bottom v-if="worksheetsettings.labels && worksheetsettings.labels.history.hpi.location">
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-icon
                                                            color="primary"
                                                            :dark="proMode"
                                                            v-bind="attrs"
                                                            v-on="on"
                                                        >
                                                            mdi-information-outline
                                                        </v-icon>
                                                    </template>
                                                    <span>{{worksheetsettings.labels.history.hpi.location}}</span>
                                                </v-tooltip>
                                            </template>
                                        </v-checkbox>
                                    </v-col>
                                    <v-col cols="3" style="height:50px;" :class="'text-center ' + (proMode ? 'checkBoxBorderedDK' : 'checkBoxBorderedLT')">
                                        <v-checkbox @change="calculateMDM" 
                                            style="margin:7px 5px;"
                                            class="nextDay"
                                            v-model="mdmVal.worksheet.history.hpi.quality"
                                            :label="(qaEnc && mdmQaVal ? 'Quality: ' + mdmQaVal.worksheet.history.hpi.quality + (mdmQaVal.worksheet.history.hpi.quality == mdmVal.worksheet.history.hpi.quality ? ' - ✓' : ' - ✗' ) : 'Quality')"
                                        >
                                            <template v-slot:append>
                                                <v-tooltip max-width="350px" bottom v-if="worksheetsettings.labels && worksheetsettings.labels.history.hpi.quality">
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-icon
                                                            color="primary"
                                                            :dark="proMode"
                                                            v-bind="attrs"
                                                            v-on="on"
                                                        >
                                                            mdi-information-outline
                                                        </v-icon>
                                                    </template>
                                                    <span>{{worksheetsettings.labels.history.hpi.quality}}</span>
                                                </v-tooltip>
                                            </template>
                                        </v-checkbox>
                                    </v-col>
                                    <v-col cols="3" style="height:50px;" :class="'text-center ' + (proMode ? 'checkBoxBorderedDK' : 'checkBoxBorderedLT')">
                                        <v-checkbox @change="calculateMDM" 
                                            style="margin:7px 5px;"
                                            class="nextDay"
                                            v-model="mdmVal.worksheet.history.hpi.severity"
                                            :label="(qaEnc && mdmQaVal ? 'Severity: ' + mdmQaVal.worksheet.history.hpi.severity + (mdmQaVal.worksheet.history.hpi.severity == mdmVal.worksheet.history.hpi.severity ? ' - ✓' : ' - ✗' ) : 'Severity')"
                                        >
                                            <template v-slot:append>
                                                <v-tooltip max-width="350px" bottom v-if="worksheetsettings.labels && worksheetsettings.labels.history.hpi.severity">
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-icon
                                                            color="primary"
                                                            :dark="proMode"
                                                            v-bind="attrs"
                                                            v-on="on"
                                                        >
                                                            mdi-information-outline
                                                        </v-icon>
                                                    </template>
                                                    <span>{{worksheetsettings.labels.history.hpi.severity}}</span>
                                                </v-tooltip>
                                            </template>
                                        </v-checkbox>
                                    </v-col>
                                    <v-col cols="3" style="height:50px;" :class="'text-center ' + (proMode ? 'checkBoxBorderedDK' : 'checkBoxBorderedLT')">
                                        <v-checkbox @change="calculateMDM" 
                                            style="margin:7px 5px;"
                                            class="nextDay"
                                            v-model="mdmVal.worksheet.history.hpi.duration"
                                            :label="(qaEnc && mdmQaVal ? 'Duration: ' + mdmQaVal.worksheet.history.hpi.duration + (mdmQaVal.worksheet.history.hpi.duration == mdmVal.worksheet.history.hpi.duration ? ' - ✓' : ' - ✗' ) : 'Duration')"
                                        >
                                            <template v-slot:append>
                                                <v-tooltip max-width="350px" bottom v-if="worksheetsettings.labels && worksheetsettings.labels.history.hpi.duration">
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-icon
                                                            color="primary"
                                                            :dark="proMode"
                                                            v-bind="attrs"
                                                            v-on="on"
                                                        >
                                                            mdi-information-outline
                                                        </v-icon>
                                                    </template>
                                                    <span>{{worksheetsettings.labels.history.hpi.duration}}</span>
                                                </v-tooltip>
                                            </template>
                                        </v-checkbox>
                                    </v-col>
                                </v-row>
                                <v-row no-gutters class="pb-0" style="height:50px;">
                                    <v-col cols="3" style="height:50px;" :class="'text-center ' + (proMode ? 'checkBoxBorderedDK' : 'checkBoxBorderedLT')">
                                        <v-checkbox @change="calculateMDM" 
                                            style="margin:7px 5px;"
                                            class="nextDay"
                                            v-model="mdmVal.worksheet.history.hpi.timing"
                                            :label="(qaEnc && mdmQaVal ? 'Timing: ' + mdmQaVal.worksheet.history.hpi.timing + (mdmQaVal.worksheet.history.hpi.timing == mdmVal.worksheet.history.hpi.timing ? ' - ✓' : ' - ✗' ) : 'Timing')"
                                        >
                                            <template v-slot:append>
                                                <v-tooltip max-width="350px" bottom v-if="worksheetsettings.labels && worksheetsettings.labels.history.hpi.timing">
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-icon
                                                            color="primary"
                                                            :dark="proMode"
                                                            v-bind="attrs"
                                                            v-on="on"
                                                        >
                                                            mdi-information-outline
                                                        </v-icon>
                                                    </template>
                                                    <span>{{worksheetsettings.labels.history.hpi.timing}}</span>
                                                </v-tooltip>
                                            </template>
                                        </v-checkbox>
                                    </v-col>
                                    <v-col cols="3" style="height:50px;" :class="'text-center ' + (proMode ? 'checkBoxBorderedDK' : 'checkBoxBorderedLT')">
                                        <v-checkbox @change="calculateMDM" 
                                            style="margin:7px 5px;"
                                            class="nextDay"
                                            v-model="mdmVal.worksheet.history.hpi.context"
                                            :label="(qaEnc && mdmQaVal ? 'Context: ' + mdmQaVal.worksheet.history.hpi.context + (mdmQaVal.worksheet.history.hpi.context == mdmVal.worksheet.history.hpi.context ? ' - ✓' : ' - ✗' ) : 'Context')"
                                        >
                                            <template v-slot:append>
                                                <v-tooltip max-width="350px" bottom v-if="worksheetsettings.labels && worksheetsettings.labels.history.hpi.context">
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-icon
                                                            color="primary"
                                                            :dark="proMode"
                                                            v-bind="attrs"
                                                            v-on="on"
                                                        >
                                                            mdi-information-outline
                                                        </v-icon>
                                                    </template>
                                                    <span>{{worksheetsettings.labels.history.hpi.context}}</span>
                                                </v-tooltip>
                                            </template>
                                        </v-checkbox>
                                    </v-col>
                                    <v-col cols="3" style="height:50px;" :class="'text-center ' + (proMode ? 'checkBoxBorderedDK' : 'checkBoxBorderedLT')">
                                        <v-checkbox @change="calculateMDM" 
                                            style="margin:7px 5px;"
                                            class="nextDay"
                                            v-model="mdmVal.worksheet.history.hpi.modifying_factors"
                                            :label="(qaEnc && mdmQaVal ? 'Mod Fact: ' + mdmQaVal.worksheet.history.hpi.modifying_factors + (mdmQaVal.worksheet.history.hpi.modifying_factors == mdmVal.worksheet.history.hpi.modifying_factors ? ' - ✓' : ' - ✗' ) : 'Modifying Factors')"
                                        >
                                            <template v-slot:append>
                                                <v-tooltip max-width="350px" bottom v-if="worksheetsettings.labels && worksheetsettings.labels.history.hpi.modifying_factors">
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-icon
                                                            color="primary"
                                                            :dark="proMode"
                                                            v-bind="attrs"
                                                            v-on="on"
                                                        >
                                                            mdi-information-outline
                                                        </v-icon>
                                                    </template>
                                                    <span>{{worksheetsettings.labels.history.hpi.modifying_factors}}</span>
                                                </v-tooltip>
                                            </template>
                                        </v-checkbox>
                                    </v-col>
                                    <v-col cols="3" style="height:50px;" :class="'text-center ' + (proMode ? 'checkBoxBorderedDK' : 'checkBoxBorderedLT')">
                                        <v-checkbox @change="calculateMDM" 
                                            style="margin:7px 5px;"
                                            class="nextDay"
                                            v-model="mdmVal.worksheet.history.hpi.associated_signs_and_symptoms"
                                            :label="(qaEnc && mdmQaVal ? 'Assoc Signs: ' + mdmQaVal.worksheet.history.hpi.associated_signs_and_symptoms + (mdmQaVal.worksheet.history.hpi.associated_signs_and_symptoms == mdmVal.worksheet.history.hpi.associated_signs_and_symptoms ? ' - ✓' : ' - ✗' ) : 'Assoc. Signs & Symptoms')"
                                        >
                                            <template v-slot:append>
                                                <v-tooltip max-width="350px" bottom v-if="worksheetsettings.labels && worksheetsettings.labels.history.hpi.associated_signs_and_symptoms">
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-icon
                                                            color="primary"
                                                            :dark="proMode"
                                                            v-bind="attrs"
                                                            v-on="on"
                                                        >
                                                            mdi-information-outline
                                                        </v-icon>
                                                    </template>
                                                    <span>{{worksheetsettings.labels.history.hpi.associated_signs_and_symptoms}}</span>
                                                </v-tooltip>
                                            </template>
                                        </v-checkbox>
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>

                        <v-row no-gutters class="pb-2">
                            <v-col cols="12">
                                <v-row no-gutters class="pb-0">
                                    <v-col cols="12" :class="'text-center text-h6 ' + (proMode ? 'checkBoxBorderedDK' : 'checkBoxBorderedLT')">
                                        Review of Systems (ROS)  
                                        <v-tooltip max-width="350px" bottom v-if="worksheetsettings.labels && worksheetsettings.labels.history.ros.header">
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-icon
                                                    color="primary"
                                                    :dark="proMode"
                                                    v-bind="attrs"
                                                    v-on="on"
                                                >
                                                    mdi-information-outline
                                                </v-icon>
                                            </template>
                                            <span>{{worksheetsettings.labels.history.ros.header}}</span>
                                        </v-tooltip>
                                    </v-col>
                                </v-row>
                                <v-row no-gutters class="pb-0" style="height:50px;">
                                    <v-col cols="2" style="height:50px;" :class="'text-center ' + (proMode ? 'checkBoxBorderedDK' : 'checkBoxBorderedLT')">
                                        <v-checkbox @change="calculateMDM" 
                                            style="margin:7px 5px;"
                                            class="nextDay"
                                            v-model="mdmVal.worksheet.history.ros.all_other_systems_negative"
                                            :label="(qaEnc && mdmQaVal ? 'All Negative: ' + mdmQaVal.worksheet.history.ros.all_other_systems_negative + (mdmQaVal.worksheet.history.ros.all_other_systems_negative == mdmVal.worksheet.history.ros.all_other_systems_negative ? ' - ✓' : ' - ✗' ) : 'All Other Sys Neg')"
                                        >
                                            <template v-slot:append>
                                                <v-tooltip max-width="350px" bottom v-if="worksheetsettings.labels && worksheetsettings.labels.history.ros.all_other_systems_negative">
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-icon
                                                            color="primary"
                                                            :dark="proMode"
                                                            v-bind="attrs"
                                                            v-on="on"
                                                        >
                                                            mdi-information-outline
                                                        </v-icon>
                                                    </template>
                                                    <span>{{worksheetsettings.labels.history.ros.all_other_systems_negative}}</span>
                                                </v-tooltip>
                                            </template>
                                        </v-checkbox>
                                    </v-col>
                                    <v-col cols="2" style="height:50px;" :class="'text-center ' + (proMode ? 'checkBoxBorderedDK' : 'checkBoxBorderedLT')">
                                        <v-checkbox @change="calculateMDM" 
                                            style="margin:7px 5px;"
                                            class="nextDay"
                                            v-model="mdmVal.worksheet.history.ros.allergic_immunologic"
                                            :label="(qaEnc && mdmQaVal ? 'Allerg/Immuno: ' + mdmQaVal.worksheet.history.ros.allergic_immunologic + (mdmQaVal.worksheet.history.ros.allergic_immunologic == mdmVal.worksheet.history.ros.allergic_immunologic ? ' - ✓' : ' - ✗' ) : 'Allergic / Immunologic')"
                                        >
                                            <template v-slot:append>
                                                <v-tooltip max-width="350px" bottom v-if="worksheetsettings.labels && worksheetsettings.labels.history.ros.allergic_immunologic">
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-icon
                                                            color="primary"
                                                            :dark="proMode"
                                                            v-bind="attrs"
                                                            v-on="on"
                                                        >
                                                            mdi-information-outline
                                                        </v-icon>
                                                    </template>
                                                    <span>{{worksheetsettings.labels.history.ros.allergic_immunologic}}</span>
                                                </v-tooltip>
                                            </template>
                                        </v-checkbox>
                                    </v-col>
                                    <v-col cols="2" style="height:50px;" :class="'text-center ' + (proMode ? 'checkBoxBorderedDK' : 'checkBoxBorderedLT')">
                                        <v-checkbox @change="calculateMDM" 
                                            style="margin:7px 5px;"
                                            class="nextDay"
                                            v-model="mdmVal.worksheet.history.ros.cardiovascular"
                                            :label="(qaEnc && mdmQaVal ? 'Cardio: ' + mdmQaVal.worksheet.history.ros.cardiovascular + (mdmQaVal.worksheet.history.ros.cardiovascular == mdmVal.worksheet.history.ros.cardiovascular ? ' - ✓' : ' - ✗' ) : 'Cardiovascular')"
                                        >
                                            <template v-slot:append>
                                                <v-tooltip max-width="350px" bottom v-if="worksheetsettings.labels && worksheetsettings.labels.history.ros.cardiovascular">
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-icon
                                                            color="primary"
                                                            :dark="proMode"
                                                            v-bind="attrs"
                                                            v-on="on"
                                                        >
                                                            mdi-information-outline
                                                        </v-icon>
                                                    </template>
                                                    <span>{{worksheetsettings.labels.history.ros.cardiovascular}}</span>
                                                </v-tooltip>
                                            </template>
                                        </v-checkbox>
                                    </v-col>
                                    <v-col cols="2" style="height:50px;" :class="'text-center ' + (proMode ? 'checkBoxBorderedDK' : 'checkBoxBorderedLT')">
                                        <v-checkbox @change="calculateMDM" 
                                            style="margin:7px 5px;"
                                            class="nextDay"
                                            v-model="mdmVal.worksheet.history.ros.constitutional"
                                            :label="(qaEnc && mdmQaVal ? 'Constit: ' + mdmQaVal.worksheet.history.ros.constitutional + (mdmQaVal.worksheet.history.ros.constitutional == mdmVal.worksheet.history.ros.constitutional ? ' - ✓' : ' - ✗' ) : 'Constitutional')"
                                        >
                                            <template v-slot:append>
                                                <v-tooltip max-width="350px" bottom v-if="worksheetsettings.labels && worksheetsettings.labels.history.ros.constitutional">
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-icon
                                                            color="primary"
                                                            :dark="proMode"
                                                            v-bind="attrs"
                                                            v-on="on"
                                                        >
                                                            mdi-information-outline
                                                        </v-icon>
                                                    </template>
                                                    <span>{{worksheetsettings.labels.history.ros.constitutional}}</span>
                                                </v-tooltip>
                                            </template>
                                        </v-checkbox>
                                    </v-col>
                                    <v-col cols="2" style="height:50px;" :class="'text-center ' + (proMode ? 'checkBoxBorderedDK' : 'checkBoxBorderedLT')">
                                        <v-checkbox @change="calculateMDM" 
                                            style="margin:7px 5px;"
                                            class="nextDay"
                                            v-model="mdmVal.worksheet.history.ros.ed_caveat"
                                            :label="(qaEnc && mdmQaVal ? 'ED Cav: ' + mdmQaVal.worksheet.history.ros.ed_caveat + (mdmQaVal.worksheet.history.ros.ed_caveat == mdmVal.worksheet.history.ros.ed_caveat ? ' - ✓' : ' - ✗' ) : 'ED Caveat')"
                                        >
                                            <template v-slot:append>
                                                <v-tooltip max-width="350px" bottom v-if="worksheetsettings.labels && worksheetsettings.labels.history.ros.ed_caveat">
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-icon
                                                            color="primary"
                                                            :dark="proMode"
                                                            v-bind="attrs"
                                                            v-on="on"
                                                        >
                                                            mdi-information-outline
                                                        </v-icon>
                                                    </template>
                                                    <span>{{worksheetsettings.labels.history.ros.ed_caveat}}</span>
                                                </v-tooltip>
                                            </template>
                                        </v-checkbox>
                                    </v-col>
                                    <v-col cols="2" style="height:50px;" :class="'text-center ' + (proMode ? 'checkBoxBorderedDK' : 'checkBoxBorderedLT')">
                                        <v-checkbox @change="calculateMDM" 
                                            style="margin:7px 5px;"
                                            class="nextDay"
                                            v-model="mdmVal.worksheet.history.ros.endocrine"
                                            :label="(qaEnc && mdmQaVal ? 'Endo: ' + mdmQaVal.worksheet.history.ros.endocrine + (mdmQaVal.worksheet.history.ros.endocrine == mdmVal.worksheet.history.ros.endocrine ? ' - ✓' : ' - ✗' ) : 'Endocrine')"
                                        >
                                            <template v-slot:append>
                                                <v-tooltip max-width="350px" bottom v-if="worksheetsettings.labels && worksheetsettings.labels.history.ros.endocrine">
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-icon
                                                            color="primary"
                                                            :dark="proMode"
                                                            v-bind="attrs"
                                                            v-on="on"
                                                        >
                                                            mdi-information-outline
                                                        </v-icon>
                                                    </template>
                                                    <span>{{worksheetsettings.labels.history.ros.endocrine}}</span>
                                                </v-tooltip>
                                            </template>
                                        </v-checkbox>
                                    </v-col>
                                </v-row>
                                <v-row no-gutters class="pb-0" style="height:50px;">
                                    <v-col cols="2" style="height:50px;" :class="'text-center ' + (proMode ? 'checkBoxBorderedDK' : 'checkBoxBorderedLT')">
                                        <v-checkbox @change="calculateMDM" 
                                            style="margin:7px 5px;"
                                            class="nextDay"
                                            v-model="mdmVal.worksheet.history.ros.ent"
                                            :label="(qaEnc && mdmQaVal ? 'ENT: ' + mdmQaVal.worksheet.history.ros.ent + (mdmQaVal.worksheet.history.ros.ent == mdmVal.worksheet.history.ros.ent ? ' - ✓' : ' - ✗' ) : 'ENT')"
                                        >
                                            <template v-slot:append>
                                                <v-tooltip max-width="350px" bottom v-if="worksheetsettings.labels && worksheetsettings.labels.history.ros.ent">
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-icon
                                                            color="primary"
                                                            :dark="proMode"
                                                            v-bind="attrs"
                                                            v-on="on"
                                                        >
                                                            mdi-information-outline
                                                        </v-icon>
                                                    </template>
                                                    <span>{{worksheetsettings.labels.history.ros.ent}}</span>
                                                </v-tooltip>
                                            </template>
                                        </v-checkbox>
                                    </v-col>
                                    <v-col cols="2" style="height:50px;" :class="'text-center ' + (proMode ? 'checkBoxBorderedDK' : 'checkBoxBorderedLT')">
                                        <v-checkbox @change="calculateMDM" 
                                            style="margin:7px 5px;"
                                            class="nextDay"
                                            v-model="mdmVal.worksheet.history.ros.eyes"
                                            :label="(qaEnc && mdmQaVal ? 'Eyes: ' + mdmQaVal.worksheet.history.ros.eyes + (mdmQaVal.worksheet.history.ros.eyes == mdmVal.worksheet.history.ros.eyes ? ' - ✓' : ' - ✗' ) : 'Eyes')"
                                        >
                                            <template v-slot:append>
                                                <v-tooltip max-width="350px" bottom v-if="worksheetsettings.labels && worksheetsettings.labels.history.ros.eyes">
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-icon
                                                            color="primary"
                                                            :dark="proMode"
                                                            v-bind="attrs"
                                                            v-on="on"
                                                        >
                                                            mdi-information-outline
                                                        </v-icon>
                                                    </template>
                                                    <span>{{worksheetsettings.labels.history.ros.eyes}}</span>
                                                </v-tooltip>
                                            </template>
                                        </v-checkbox>
                                    </v-col>
                                    <v-col cols="2" style="height:50px;" :class="'text-center ' + (proMode ? 'checkBoxBorderedDK' : 'checkBoxBorderedLT')">
                                        <v-checkbox @change="calculateMDM" 
                                            style="margin:7px 5px;"
                                            class="nextDay"
                                            v-model="mdmVal.worksheet.history.ros.gi"
                                            :label="(qaEnc && mdmQaVal ? 'GI: ' + mdmQaVal.worksheet.history.ros.gi + (mdmQaVal.worksheet.history.ros.gi == mdmVal.worksheet.history.ros.gi ? ' - ✓' : ' - ✗' ) : 'GI')"
                                        >
                                            <template v-slot:append>
                                                <v-tooltip max-width="350px" bottom v-if="worksheetsettings.labels && worksheetsettings.labels.history.ros.gi">
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-icon
                                                            color="primary"
                                                            :dark="proMode"
                                                            v-bind="attrs"
                                                            v-on="on"
                                                        >
                                                            mdi-information-outline
                                                        </v-icon>
                                                    </template>
                                                    <span>{{worksheetsettings.labels.history.ros.gi}}</span>
                                                </v-tooltip>
                                            </template>
                                        </v-checkbox>
                                    </v-col>
                                    <v-col cols="2" style="height:50px;" :class="'text-center ' + (proMode ? 'checkBoxBorderedDK' : 'checkBoxBorderedLT')">
                                        <v-checkbox @change="calculateMDM" 
                                            style="margin:7px 5px;"
                                            class="nextDay"
                                            v-model="mdmVal.worksheet.history.ros.gu"
                                            :label="(qaEnc && mdmQaVal ? 'GU: ' + mdmQaVal.worksheet.history.ros.gu + (mdmQaVal.worksheet.history.ros.gu == mdmVal.worksheet.history.ros.gu ? ' - ✓' : ' - ✗' ) : 'GU')"
                                        >
                                            <template v-slot:append>
                                                <v-tooltip max-width="350px" bottom v-if="worksheetsettings.labels && worksheetsettings.labels.history.ros.gu">
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-icon
                                                            color="primary"
                                                            :dark="proMode"
                                                            v-bind="attrs"
                                                            v-on="on"
                                                        >
                                                            mdi-information-outline
                                                        </v-icon>
                                                    </template>
                                                    <span>{{worksheetsettings.labels.history.ros.gu}}</span>
                                                </v-tooltip>
                                            </template>
                                        </v-checkbox>
                                    </v-col>
                                    <v-col cols="2" style="height:50px;" :class="'text-center ' + (proMode ? 'checkBoxBorderedDK' : 'checkBoxBorderedLT')">
                                        <v-checkbox @change="calculateMDM" 
                                            style="margin:7px 5px;"
                                            class="nextDay"
                                            v-model="mdmVal.worksheet.history.ros.hematologic_lymphatic"
                                            :label="(qaEnc && mdmQaVal ? 'Hem/Lym: ' + mdmQaVal.worksheet.history.ros.hematologic_lymphatic + (mdmQaVal.worksheet.history.ros.hematologic_lymphatic == mdmVal.worksheet.history.ros.hematologic_lymphatic ? ' - ✓' : ' - ✗' ) : 'Hematologic / Lymphatic')"
                                        >
                                            <template v-slot:append>
                                                <v-tooltip max-width="350px" bottom v-if="worksheetsettings.labels && worksheetsettings.labels.history.ros.hematologic_lymphatic">
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-icon
                                                            color="primary"
                                                            :dark="proMode"
                                                            v-bind="attrs"
                                                            v-on="on"
                                                        >
                                                            mdi-information-outline
                                                        </v-icon>
                                                    </template>
                                                    <span>{{worksheetsettings.labels.history.ros.hematologic_lymphatic}}</span>
                                                </v-tooltip>
                                            </template>
                                        </v-checkbox>
                                    </v-col>
                                    <v-col cols="2" style="height:50px;" :class="'text-center ' + (proMode ? 'checkBoxBorderedDK' : 'checkBoxBorderedLT')">
                                        <v-checkbox @change="calculateMDM" 
                                            style="margin:7px 5px;"
                                            class="nextDay"
                                            v-model="mdmVal.worksheet.history.ros.integumentary"
                                            :label="(qaEnc && mdmQaVal ? 'Integ: ' + mdmQaVal.worksheet.history.ros.integumentary + (mdmQaVal.worksheet.history.ros.integumentary == mdmVal.worksheet.history.ros.integumentary ? ' - ✓' : ' - ✗' ) : 'Integumentary')"
                                        >
                                            <template v-slot:append>
                                                <v-tooltip max-width="350px" bottom v-if="worksheetsettings.labels && worksheetsettings.labels.history.ros.integumentary">
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-icon
                                                            color="primary"
                                                            :dark="proMode"
                                                            v-bind="attrs"
                                                            v-on="on"
                                                        >
                                                            mdi-information-outline
                                                        </v-icon>
                                                    </template>
                                                    <span>{{worksheetsettings.labels.history.ros.integumentary}}</span>
                                                </v-tooltip>
                                            </template>
                                        </v-checkbox>
                                    </v-col>
                                </v-row>
                                <v-row no-gutters class="pb-0" style="height:50px;">
                                    <v-col cols="3" style="height:50px;" :class="'text-center ' + (proMode ? 'checkBoxBorderedDK' : 'checkBoxBorderedLT')">
                                        <v-checkbox @change="calculateMDM" 
                                            style="margin:7px 5px;"
                                            class="nextDay"
                                            v-model="mdmVal.worksheet.history.ros.musculoskeletal"
                                            :label="(qaEnc && mdmQaVal ? 'Musc: ' + mdmQaVal.worksheet.history.ros.musculoskeletal + (mdmQaVal.worksheet.history.ros.musculoskeletal == mdmVal.worksheet.history.ros.musculoskeletal ? ' - ✓' : ' - ✗' ) : 'Musculoskeletal')"
                                        >
                                            <template v-slot:append>
                                                <v-tooltip max-width="350px" bottom v-if="worksheetsettings.labels && worksheetsettings.labels.history.ros.musculoskeletal">
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-icon
                                                            color="primary"
                                                            :dark="proMode"
                                                            v-bind="attrs"
                                                            v-on="on"
                                                        >
                                                            mdi-information-outline
                                                        </v-icon>
                                                    </template>
                                                    <span>{{worksheetsettings.labels.history.ros.musculoskeletal}}</span>
                                                </v-tooltip>
                                            </template>
                                        </v-checkbox>
                                    </v-col>
                                    <v-col cols="3" style="height:50px;" :class="'text-center ' + (proMode ? 'checkBoxBorderedDK' : 'checkBoxBorderedLT')">
                                        <v-checkbox @change="calculateMDM" 
                                            style="margin:7px 5px;"
                                            class="nextDay"
                                            v-model="mdmVal.worksheet.history.ros.neurologic"
                                            :label="(qaEnc && mdmQaVal ? 'Neuro: ' + mdmQaVal.worksheet.history.ros.neurologic + (mdmQaVal.worksheet.history.ros.neurologic == mdmVal.worksheet.history.ros.neurologic ? ' - ✓' : ' - ✗' ) : 'Neurologic')"
                                        >
                                            <template v-slot:append>
                                                <v-tooltip max-width="350px" bottom v-if="worksheetsettings.labels && worksheetsettings.labels.history.ros.neurologic">
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-icon
                                                            color="primary"
                                                            :dark="proMode"
                                                            v-bind="attrs"
                                                            v-on="on"
                                                        >
                                                            mdi-information-outline
                                                        </v-icon>
                                                    </template>
                                                    <span>{{worksheetsettings.labels.history.ros.neurologic}}</span>
                                                </v-tooltip>
                                            </template>
                                        </v-checkbox>
                                    </v-col>
                                    <v-col cols="3" style="height:50px;" :class="'text-center ' + (proMode ? 'checkBoxBorderedDK' : 'checkBoxBorderedLT')">
                                        <v-checkbox @change="calculateMDM" 
                                            style="margin:7px 5px;"
                                            class="nextDay"
                                            v-model="mdmVal.worksheet.history.ros.psychiatric"
                                            :label="(qaEnc && mdmQaVal ? 'Psych: ' + mdmQaVal.worksheet.history.ros.psychiatric + (mdmQaVal.worksheet.history.ros.psychiatric == mdmVal.worksheet.history.ros.psychiatric ? ' - ✓' : ' - ✗' ) : 'Psychiatric')"
                                        >
                                            <template v-slot:append>
                                                <v-tooltip max-width="350px" bottom v-if="worksheetsettings.labels && worksheetsettings.labels.history.ros.psychiatric">
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-icon
                                                            color="primary"
                                                            :dark="proMode"
                                                            v-bind="attrs"
                                                            v-on="on"
                                                        >
                                                            mdi-information-outline
                                                        </v-icon>
                                                    </template>
                                                    <span>{{worksheetsettings.labels.history.ros.psychiatric}}</span>
                                                </v-tooltip>
                                            </template>
                                        </v-checkbox>
                                    </v-col>
                                    <v-col cols="3" style="height:50px;" :class="'text-center ' + (proMode ? 'checkBoxBorderedDK' : 'checkBoxBorderedLT')">
                                        <v-checkbox @change="calculateMDM" 
                                            style="margin:7px 5px;"
                                            class="nextDay"
                                            v-model="mdmVal.worksheet.history.ros.respiratory"
                                            :label="(qaEnc && mdmQaVal ? 'Resp: ' + mdmQaVal.worksheet.history.ros.respiratory + (mdmQaVal.worksheet.history.ros.respiratory == mdmVal.worksheet.history.ros.respiratory ? ' - ✓' : ' - ✗' ) : 'Respiratory')"
                                        >
                                            <template v-slot:append>
                                                <v-tooltip max-width="350px" bottom v-if="worksheetsettings.labels && worksheetsettings.labels.history.ros.respiratory">
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-icon
                                                            color="primary"
                                                            :dark="proMode"
                                                            v-bind="attrs"
                                                            v-on="on"
                                                        >
                                                            mdi-information-outline
                                                        </v-icon>
                                                    </template>
                                                    <span>{{worksheetsettings.labels.history.ros.respiratory}}</span>
                                                </v-tooltip>
                                            </template>
                                        </v-checkbox>
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>

                        <v-row no-gutters class="pb-2">
                            <v-col cols="12">
                                <v-row no-gutters class="pb-0">
                                    <v-col cols="12" :class="'text-center text-h6 ' + (proMode ? 'checkBoxBorderedDK' : 'checkBoxBorderedLT')">
                                        Past Family Social History (PFSHx)  
                                        <v-tooltip max-width="350px" bottom v-if="worksheetsettings.labels && worksheetsettings.labels.history.pfshx.header">
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-icon
                                                    color="primary"
                                                    :dark="proMode"
                                                    v-bind="attrs"
                                                    v-on="on"
                                                >
                                                    mdi-information-outline
                                                </v-icon>
                                            </template>
                                            <span>{{worksheetsettings.labels.history.pfshx.header}}</span>
                                        </v-tooltip>
                                    </v-col>
                                </v-row>
                                <v-row no-gutters class="pb-0" style="height:50px;">
                                    <v-col cols="4" style="height:50px;" :class="'text-center ' + (proMode ? 'checkBoxBorderedDK' : 'checkBoxBorderedLT')">
                                        <v-checkbox @change="calculateMDM" 
                                            style="margin:7px 5px;"
                                            class="nextDay"
                                            v-model="mdmVal.worksheet.history.pfshx.past_medical"
                                            :label="(qaEnc && mdmQaVal ? 'Past Medical: ' + mdmQaVal.worksheet.history.pfshx.past_medical + (mdmQaVal.worksheet.history.pfshx.past_medical == mdmVal.worksheet.history.pfshx.past_medical ? ' - ✓' : ' - ✗' ) : 'Past Medical')"
                                        >
                                            <template v-slot:append>
                                                <v-tooltip max-width="350px" bottom v-if="worksheetsettings.labels && worksheetsettings.labels.history.pfshx.past_medical">
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-icon
                                                            color="primary"
                                                            :dark="proMode"
                                                            v-bind="attrs"
                                                            v-on="on"
                                                        >
                                                            mdi-information-outline
                                                        </v-icon>
                                                    </template>
                                                    <span>{{worksheetsettings.labels.history.pfshx.past_medical}}</span>
                                                </v-tooltip>
                                            </template>
                                        </v-checkbox>
                                    </v-col>
                                    <v-col cols="4" style="height:50px;" :class="'text-center ' + (proMode ? 'checkBoxBorderedDK' : 'checkBoxBorderedLT')">
                                        <v-checkbox @change="calculateMDM" 
                                            style="margin:7px 5px;"
                                            class="nextDay"
                                            v-model="mdmVal.worksheet.history.pfshx.family_history"
                                            :label="(qaEnc && mdmQaVal ? 'Family History: ' + mdmQaVal.worksheet.history.pfshx.family_history + (mdmQaVal.worksheet.history.pfshx.family_history == mdmVal.worksheet.history.pfshx.family_history ? ' - ✓' : ' - ✗' ) : 'Family History')"
                                        >
                                            <template v-slot:append>
                                                <v-tooltip max-width="350px" bottom v-if="worksheetsettings.labels && worksheetsettings.labels.history.pfshx.family_history">
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-icon
                                                            color="primary"
                                                            :dark="proMode"
                                                            v-bind="attrs"
                                                            v-on="on"
                                                        >
                                                            mdi-information-outline
                                                        </v-icon>
                                                    </template>
                                                    <span>{{worksheetsettings.labels.history.pfshx.family_history}}</span>
                                                </v-tooltip>
                                            </template>
                                        </v-checkbox>
                                    </v-col>
                                    <v-col cols="4" style="height:50px;" :class="'text-center ' + (proMode ? 'checkBoxBorderedDK' : 'checkBoxBorderedLT')">
                                        <v-checkbox @change="calculateMDM" 
                                            style="margin:7px 5px;"
                                            class="nextDay"
                                            v-model="mdmVal.worksheet.history.pfshx.social_history"
                                            :label="(qaEnc && mdmQaVal ? 'Social History: ' + mdmQaVal.worksheet.history.pfshx.social_history + (mdmQaVal.worksheet.history.pfshx.social_history == mdmVal.worksheet.history.pfshx.social_history ? ' - ✓' : ' - ✗' ) : 'Social History')"
                                        >
                                            <template v-slot:append>
                                                <v-tooltip max-width="350px" bottom v-if="worksheetsettings.labels && worksheetsettings.labels.history.pfshx.social_history">
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-icon
                                                            color="primary"
                                                            :dark="proMode"
                                                            v-bind="attrs"
                                                            v-on="on"
                                                        >
                                                            mdi-information-outline
                                                        </v-icon>
                                                    </template>
                                                    <span>{{worksheetsettings.labels.history.pfshx.social_history}}</span>
                                                </v-tooltip>
                                            </template>
                                        </v-checkbox>
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>


                    </v-expansion-panel-content>
                </v-expansion-panel>
                <v-expansion-panel
                    key="exam"
                >
                    <v-expansion-panel-header class="py-0" :color = "(proMode ? 'rgba(255, 255, 255, 0.08)':'rgba(0, 0, 0, 0.08)')" :style="'border-bottom:solid 1px ' + (proMode ? 'rgba(255, 255, 255, 0.12)':'rgba(0, 0, 0, 0.12)')">
                        Exam {{(emToolPro.exam ? " - " + emToolPro.exam : "")}}
                    </v-expansion-panel-header>
                    <v-expansion-panel-content class="px-2 mx-0 py-2">
                        <v-row no-gutters class="pb-2">
                            <v-col cols="12">
                                <v-row no-gutters class="pb-0">
                                    <v-col cols="12" :class="'text-center text-h6 ' + (proMode ? 'checkBoxBorderedDK' : 'checkBoxBorderedLT')">
                                        Physical Examination (PE) 
                                        <v-tooltip max-width="350px" bottom v-if="worksheetsettings.labels && worksheetsettings.labels.exam.header">
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-icon
                                                    color="primary"
                                                    :dark="proMode"
                                                    v-bind="attrs"
                                                    v-on="on"
                                                >
                                                    mdi-information-outline
                                                </v-icon>
                                            </template>
                                            <span>{{worksheetsettings.labels.exam.header}}</span>
                                        </v-tooltip>
                                    </v-col>
                                </v-row>
                                <v-row no-gutters class="pb-0" style="height:50px;">
                                    <v-col cols="2" style="height:50px;" :class="'text-center ' + (proMode ? 'checkBoxBorderedDK' : 'checkBoxBorderedLT')">
                                        <v-checkbox @change="calculateMDM" 
                                            style="margin:7px 5px;"
                                            class="nextDay"
                                            v-model="mdmVal.worksheet.exam.cardiovascular"
                                            :label="(qaEnc && mdmQaVal ? 'Cardio: ' + mdmQaVal.worksheet.exam.cardiovascular + (mdmQaVal.worksheet.exam.cardiovascular == mdmVal.worksheet.exam.cardiovascular ? ' - ✓' : ' - ✗' ) : 'Cardiovascular')"
                                        >
                                            <template v-slot:append>
                                                <v-tooltip max-width="350px" bottom v-if="worksheetsettings.labels && worksheetsettings.labels.exam.cardiovascular">
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-icon
                                                            color="primary"
                                                            :dark="proMode"
                                                            v-bind="attrs"
                                                            v-on="on"
                                                        >
                                                            mdi-information-outline
                                                        </v-icon>
                                                    </template>
                                                    <span>{{worksheetsettings.labels.exam.cardiovascular}}</span>
                                                </v-tooltip>
                                            </template>
                                        </v-checkbox>
                                    </v-col>
                                    <v-col cols="2" style="height:50px;" :class="'text-center ' + (proMode ? 'checkBoxBorderedDK' : 'checkBoxBorderedLT')">
                                        <v-checkbox @change="calculateMDM" 
                                            style="margin:7px 5px;"
                                            class="nextDay"
                                            v-model="mdmVal.worksheet.exam.constitutional"
                                            :label="(qaEnc && mdmQaVal ? 'Constit: ' + mdmQaVal.worksheet.exam.constitutional + (mdmQaVal.worksheet.exam.constitutional == mdmVal.worksheet.exam.constitutional ? ' - ✓' : ' - ✗' ) : 'Constitutional')"
                                        >
                                            <template v-slot:append>
                                                <v-tooltip max-width="350px" bottom v-if="worksheetsettings.labels && worksheetsettings.labels.exam.constitutional">
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-icon
                                                            color="primary"
                                                            :dark="proMode"
                                                            v-bind="attrs"
                                                            v-on="on"
                                                        >
                                                            mdi-information-outline
                                                        </v-icon>
                                                    </template>
                                                    <span>{{worksheetsettings.labels.exam.constitutional}}</span>
                                                </v-tooltip>
                                            </template>
                                        </v-checkbox>
                                    </v-col>
                                    <v-col cols="2" style="height:50px;" :class="'text-center ' + (proMode ? 'checkBoxBorderedDK' : 'checkBoxBorderedLT')">
                                        <v-checkbox @change="calculateMDM" 
                                            style="margin:7px 5px;"
                                            class="nextDay"
                                            v-model="mdmVal.worksheet.exam.ent"
                                            :label="(qaEnc && mdmQaVal ? 'ENT: ' + mdmQaVal.worksheet.exam.ent + (mdmQaVal.worksheet.exam.ent == mdmVal.worksheet.exam.ent ? ' - ✓' : ' - ✗' ) : 'ENT')"
                                        >
                                            <template v-slot:append>
                                                <v-tooltip max-width="350px" bottom v-if="worksheetsettings.labels && worksheetsettings.labels.exam.ent">
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-icon
                                                            color="primary"
                                                            :dark="proMode"
                                                            v-bind="attrs"
                                                            v-on="on"
                                                        >
                                                            mdi-information-outline
                                                        </v-icon>
                                                    </template>
                                                    <span>{{worksheetsettings.labels.exam.ent}}</span>
                                                </v-tooltip>
                                            </template>
                                        </v-checkbox>
                                    </v-col>
                                    <v-col cols="2" style="height:50px;" :class="'text-center ' + (proMode ? 'checkBoxBorderedDK' : 'checkBoxBorderedLT')">
                                        <v-checkbox @change="calculateMDM" 
                                            style="margin:7px 5px;"
                                            class="nextDay"
                                            v-model="mdmVal.worksheet.exam.eyes"
                                            :label="(qaEnc && mdmQaVal ? 'Eyes: ' + mdmQaVal.worksheet.exam.eyes + (mdmQaVal.worksheet.exam.eyes == mdmVal.worksheet.exam.eyes ? ' - ✓' : ' - ✗' ) : 'Eyes')"
                                        >
                                            <template v-slot:append>
                                                <v-tooltip max-width="350px" bottom v-if="worksheetsettings.labels && worksheetsettings.labels.exam.eyes">
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-icon
                                                            color="primary"
                                                            :dark="proMode"
                                                            v-bind="attrs"
                                                            v-on="on"
                                                        >
                                                            mdi-information-outline
                                                        </v-icon>
                                                    </template>
                                                    <span>{{worksheetsettings.labels.exam.eyes}}</span>
                                                </v-tooltip>
                                            </template>
                                        </v-checkbox>
                                    </v-col>
                                    <v-col cols="2" style="height:50px;" :class="'text-center ' + (proMode ? 'checkBoxBorderedDK' : 'checkBoxBorderedLT')">
                                        <v-checkbox @change="calculateMDM" 
                                            style="margin:7px 5px;"
                                            class="nextDay"
                                            v-model="mdmVal.worksheet.exam.gi"
                                            :label="(qaEnc && mdmQaVal ? 'GI: ' + mdmQaVal.worksheet.exam.gi + (mdmQaVal.worksheet.exam.gi == mdmVal.worksheet.exam.gi ? ' - ✓' : ' - ✗' ) : 'GI')"
                                        >
                                            <template v-slot:append>
                                                <v-tooltip max-width="350px" bottom v-if="worksheetsettings.labels && worksheetsettings.labels.exam.gi">
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-icon
                                                            color="primary"
                                                            :dark="proMode"
                                                            v-bind="attrs"
                                                            v-on="on"
                                                        >
                                                            mdi-information-outline
                                                        </v-icon>
                                                    </template>
                                                    <span>{{worksheetsettings.labels.exam.gi}}</span>
                                                </v-tooltip>
                                            </template>
                                        </v-checkbox>
                                    </v-col>
                                    <v-col cols="2" style="height:50px;" :class="'text-center ' + (proMode ? 'checkBoxBorderedDK' : 'checkBoxBorderedLT')">
                                        <v-checkbox @change="calculateMDM" 
                                            style="margin:7px 5px;"
                                            class="nextDay"
                                            v-model="mdmVal.worksheet.exam.gu"
                                            :label="(qaEnc && mdmQaVal ? 'GU: ' + mdmQaVal.worksheet.exam.gu + (mdmQaVal.worksheet.exam.gu == mdmVal.worksheet.exam.gu ? ' - ✓' : ' - ✗' ) : 'GU')"
                                        >
                                            <template v-slot:append>
                                                <v-tooltip max-width="350px" bottom v-if="worksheetsettings.labels && worksheetsettings.labels.exam.gu">
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-icon
                                                            color="primary"
                                                            :dark="proMode"
                                                            v-bind="attrs"
                                                            v-on="on"
                                                        >
                                                            mdi-information-outline
                                                        </v-icon>
                                                    </template>
                                                    <span>{{worksheetsettings.labels.exam.gu}}</span>
                                                </v-tooltip>
                                            </template>
                                        </v-checkbox>
                                    </v-col>
                                </v-row>
                                <v-row no-gutters class="pb-0" style="height:50px;">
                                    <v-col cols="2" style="height:50px;" :class="'text-center ' + (proMode ? 'checkBoxBorderedDK' : 'checkBoxBorderedLT')">
                                        <v-checkbox @change="calculateMDM" 
                                            style="margin:7px 5px;"
                                            class="nextDay"
                                            v-model="mdmVal.worksheet.exam.hematologic_lymphatic"
                                            :label="(qaEnc && mdmQaVal ? 'Hem/Lym: ' + mdmQaVal.worksheet.exam.hematologic_lymphatic + (mdmQaVal.worksheet.exam.hematologic_lymphatic == mdmVal.worksheet.exam.hematologic_lymphatic ? ' - ✓' : ' - ✗' ) : 'Hematologic / Lymphatic')"
                                        >
                                            <template v-slot:append>
                                                <v-tooltip max-width="350px" bottom v-if="worksheetsettings.labels && worksheetsettings.labels.exam.hematologic_lymphatic">
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-icon
                                                            color="primary"
                                                            :dark="proMode"
                                                            v-bind="attrs"
                                                            v-on="on"
                                                        >
                                                            mdi-information-outline
                                                        </v-icon>
                                                    </template>
                                                    <span>{{worksheetsettings.labels.exam.hematologic_lymphatic}}</span>
                                                </v-tooltip>
                                            </template>
                                        </v-checkbox>
                                    </v-col>
                                    <v-col cols="2" style="height:50px;" :class="'text-center ' + (proMode ? 'checkBoxBorderedDK' : 'checkBoxBorderedLT')">
                                        <v-checkbox @change="calculateMDM" 
                                            style="margin:7px 5px;"
                                            class="nextDay"
                                            v-model="mdmVal.worksheet.exam.integumentary"
                                            :label="(qaEnc && mdmQaVal ? 'Integ: ' + mdmQaVal.worksheet.exam.integumentary + (mdmQaVal.worksheet.exam.integumentary == mdmVal.worksheet.exam.integumentary ? ' - ✓' : ' - ✗' ) : 'Integumentary')"
                                        >
                                            <template v-slot:append>
                                                <v-tooltip max-width="350px" bottom v-if="worksheetsettings.labels && worksheetsettings.labels.exam.integumentary">
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-icon
                                                            color="primary"
                                                            :dark="proMode"
                                                            v-bind="attrs"
                                                            v-on="on"
                                                        >
                                                            mdi-information-outline
                                                        </v-icon>
                                                    </template>
                                                    <span>{{worksheetsettings.labels.exam.integumentary}}</span>
                                                </v-tooltip>
                                            </template>
                                        </v-checkbox>
                                    </v-col>
                                    <v-col cols="2" style="height:50px;" :class="'text-center ' + (proMode ? 'checkBoxBorderedDK' : 'checkBoxBorderedLT')">
                                        <v-checkbox @change="calculateMDM" 
                                            style="margin:7px 5px;"
                                            class="nextDay"
                                            v-model="mdmVal.worksheet.exam.musculoskeletal"
                                            :label="(qaEnc && mdmQaVal ? 'Musc: ' + mdmQaVal.worksheet.exam.musculoskeletal + (mdmQaVal.worksheet.exam.musculoskeletal == mdmVal.worksheet.exam.musculoskeletal ? ' - ✓' : ' - ✗' ) : 'Musculoskeletal')"
                                        >
                                            <template v-slot:append>
                                                <v-tooltip max-width="350px" bottom v-if="worksheetsettings.labels && worksheetsettings.labels.exam.musculoskeletal">
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-icon
                                                            color="primary"
                                                            :dark="proMode"
                                                            v-bind="attrs"
                                                            v-on="on"
                                                        >
                                                            mdi-information-outline
                                                        </v-icon>
                                                    </template>
                                                    <span>{{worksheetsettings.labels.exam.musculoskeletal}}</span>
                                                </v-tooltip>
                                            </template>
                                        </v-checkbox>
                                    </v-col>
                                    <v-col cols="2" style="height:50px;" :class="'text-center ' + (proMode ? 'checkBoxBorderedDK' : 'checkBoxBorderedLT')">
                                        <v-checkbox @change="calculateMDM" 
                                            style="margin:7px 5px;"
                                            class="nextDay"
                                            v-model="mdmVal.worksheet.exam.neurologic"
                                            :label="(qaEnc && mdmQaVal ? 'Neuro: ' + mdmQaVal.worksheet.exam.neurologic + (mdmQaVal.worksheet.exam.neurologic == mdmVal.worksheet.exam.neurologic ? ' - ✓' : ' - ✗' ) : 'Neurologic')"
                                        >
                                            <template v-slot:append>
                                                <v-tooltip max-width="350px" bottom v-if="worksheetsettings.labels && worksheetsettings.labels.exam.neurologic">
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-icon
                                                            color="primary"
                                                            :dark="proMode"
                                                            v-bind="attrs"
                                                            v-on="on"
                                                        >
                                                            mdi-information-outline
                                                        </v-icon>
                                                    </template>
                                                    <span>{{worksheetsettings.labels.exam.neurologic}}</span>
                                                </v-tooltip>
                                            </template>
                                        </v-checkbox>
                                    </v-col>
                                    <v-col cols="2" style="height:50px;" :class="'text-center ' + (proMode ? 'checkBoxBorderedDK' : 'checkBoxBorderedLT')">
                                        <v-checkbox @change="calculateMDM" 
                                            style="margin:7px 5px;"
                                            class="nextDay"
                                            v-model="mdmVal.worksheet.exam.psychiatric"
                                            :label="(qaEnc && mdmQaVal ? 'Psych: ' + mdmQaVal.worksheet.exam.psychiatric + (mdmQaVal.worksheet.exam.psychiatric == mdmVal.worksheet.exam.psychiatric ? ' - ✓' : ' - ✗' ) : 'Psychiatric')"
                                        >
                                            <template v-slot:append>
                                                <v-tooltip max-width="350px" bottom v-if="worksheetsettings.labels && worksheetsettings.labels.exam.psychiatric">
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-icon
                                                            color="primary"
                                                            :dark="proMode"
                                                            v-bind="attrs"
                                                            v-on="on"
                                                        >
                                                            mdi-information-outline
                                                        </v-icon>
                                                    </template>
                                                    <span>{{worksheetsettings.labels.exam.psychiatric}}</span>
                                                </v-tooltip>
                                            </template>
                                        </v-checkbox>
                                    </v-col>
                                    <v-col cols="2" style="height:50px;" :class="'text-center ' + (proMode ? 'checkBoxBorderedDK' : 'checkBoxBorderedLT')">
                                        <v-checkbox @change="calculateMDM" 
                                            style="margin:7px 5px;"
                                            class="nextDay"
                                            v-model="mdmVal.worksheet.exam.respiratory"
                                            :label="(qaEnc && mdmQaVal ? 'Resp: ' + mdmQaVal.worksheet.exam.respiratory + (mdmQaVal.worksheet.exam.respiratory == mdmVal.worksheet.exam.respiratory ? ' - ✓' : ' - ✗' ) : 'Respiratory')"
                                        >
                                            <template v-slot:append>
                                                <v-tooltip max-width="350px" bottom v-if="worksheetsettings.labels && worksheetsettings.labels.exam.respiratory">
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-icon
                                                            color="primary"
                                                            :dark="proMode"
                                                            v-bind="attrs"
                                                            v-on="on"
                                                        >
                                                            mdi-information-outline
                                                        </v-icon>
                                                    </template>
                                                    <span>{{worksheetsettings.labels.exam.respiratory}}</span>
                                                </v-tooltip>
                                            </template>
                                        </v-checkbox>
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                    </v-expansion-panel-content>
                </v-expansion-panel>
                <v-expansion-panel
                    key="mdm"
                >
                    <v-expansion-panel-header class="py-0" :color = "(proMode ? 'rgba(255, 255, 255, 0.08)':'rgba(0, 0, 0, 0.08)')" :style="'border-bottom:solid 1px ' + (proMode ? 'rgba(255, 255, 255, 0.12)':'rgba(0, 0, 0, 0.12)')">
                        MDM {{(emToolPro.mdm ? " - " + emToolPro.mdm : "")}}
                    </v-expansion-panel-header>
                    <v-expansion-panel-content class="px-2 mx-0 py-2">
                        <v-row no-gutters class="pb-2">
                            <v-col cols="12">
                                <v-row no-gutters class="pb-0">
                                    <v-col cols="12" :class="'text-center text-h6 ' + (proMode ? 'checkBoxBorderedDK' : 'checkBoxBorderedLT')">
                                        A. Diagnosis and Management Options
                                        <v-tooltip max-width="350px" bottom v-if="worksheetsettings.labels && worksheetsettings.labels.mdm.table_a.header">
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-icon
                                                    color="primary"
                                                    :dark="proMode"
                                                    v-bind="attrs"
                                                    v-on="on"
                                                >
                                                    mdi-information-outline
                                                </v-icon>
                                            </template>
                                            <span>{{worksheetsettings.labels.mdm.table_a.header}}</span>
                                        </v-tooltip>
                                    </v-col>
                                </v-row>

                                <v-row no-gutters>
                                    <v-col cols="10" :class="'text-subtitle-2 text-center pa-2 ' + (proMode ? 'checkBoxBorderedDK' : 'checkBoxBorderedLT')">
                                        Option
                                    </v-col>
                                    <v-col :cols="(qaEnc ? 1 : 2)" :class="'text-subtitle-2 text-center pa-2 ' + (proMode ? 'checkBoxBorderedDK' : 'checkBoxBorderedLT')">
                                        {{(qaEnc ? 'QA' : 'TRUE?')}}
                                    </v-col>
                                    <v-col cols="1" v-if="qaEnc" :class="'text-subtitle-2 text-center pa-2 ' + (proMode ? 'checkBoxBorderedDK' : 'checkBoxBorderedLT')">
                                        Original
                                    </v-col>
                                </v-row>
                                <v-row no-gutters>
                                    <v-col cols="10" @click="(!readonly ? mdmVal.worksheet.mdm.table_a.new_problem_no_additional_workup = !mdmVal.worksheet.mdm.table_a.new_problem_no_additional_workup : '')" :class="'text-subtitle-1 pa-2 ' + (proMode ? 'checkBoxBorderedDK' : 'checkBoxBorderedLT')" :style="(readonly ? '' : 'cursor:pointer')">
                                        New Problem to examiner; NO additional work-up planned
                                        <v-tooltip max-width="350px" bottom v-if="worksheetsettings.labels && worksheetsettings.labels.mdm.table_a.new_problem_no_additional_workup">
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-icon
                                                    color="primary"
                                                    :dark="proMode"
                                                    v-bind="attrs"
                                                    v-on="on"
                                                >
                                                    mdi-information-outline
                                                </v-icon>
                                            </template>
                                            <span>{{worksheetsettings.labels.mdm.table_a.new_problem_no_additional_workup}}</span>
                                        </v-tooltip>
                                    </v-col>
                                    <v-col :cols="(qaEnc ? 1 : 2)" :class="'text-center ' + (proMode ? 'checkBoxBorderedDK' : 'checkBoxBorderedLT')">
                                        <v-checkbox @change="calculateMDM" 
                                            style="height: 20px; margin-top: 8px;"
                                            v-model="mdmVal.worksheet.mdm.table_a.new_problem_no_additional_workup"
                                        ></v-checkbox>
                                    </v-col>
                                    <v-col v-if="qaEnc" cols="1" :class="'text-center ' + (mdmVal.worksheet.mdm.table_a.new_problem_no_additional_workup != mdmQaVal.worksheet.mdm.table_a.new_problem_no_additional_workup ? 'red ' : '') + (proMode ? 'checkBoxBorderedDK' : 'checkBoxBorderedLT')">
                                        <v-checkbox @change="calculateMDM" 
                                            style="height: 20px; margin-top: 8px;"
                                            v-model="mdmQaVal.worksheet.mdm.table_a.new_problem_no_additional_workup"
                                        ></v-checkbox>
                                    </v-col>
                                </v-row>
                                
                                <v-row no-gutters>
                                    <v-col cols="10" @click="(!readonly ? mdmVal.worksheet.mdm.table_a.new_problem_workup_planned = !mdmVal.worksheet.mdm.table_a.new_problem_workup_planned : '')" :class="'text-subtitle-1 pa-2 ' + (proMode ? 'checkBoxBorderedDK' : 'checkBoxBorderedLT')" :style="(readonly ? '' : 'cursor:pointer')">
                                        New Problem to examiner; additional work-up planned
                                        <v-tooltip max-width="500px" bottom v-if="worksheetsettings.labels && worksheetsettings.labels.mdm.table_a.new_problem_workup_planned">
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-icon
                                                    color="primary"
                                                    :dark="proMode"
                                                    v-bind="attrs"
                                                    v-on="on"
                                                >
                                                    mdi-information-outline
                                                </v-icon>
                                            </template>
                                            <span>{{worksheetsettings.labels.mdm.table_a.new_problem_workup_planned}}</span>
                                        </v-tooltip>
                                    </v-col>
                                    <v-col :cols="(qaEnc ? 1 : 2)" :class="'text-center ' + (proMode ? 'checkBoxBorderedDK' : 'checkBoxBorderedLT')">
                                        <v-checkbox @change="calculateMDM" 
                                            style="height: 20px; margin-top: 8px;"
                                            v-model="mdmVal.worksheet.mdm.table_a.new_problem_workup_planned"
                                        ></v-checkbox>
                                    </v-col>
                                    <v-col v-if="qaEnc" cols="1" :class="'text-center ' + (mdmVal.worksheet.mdm.table_a.new_problem_workup_planned != mdmQaVal.worksheet.mdm.table_a.new_problem_workup_planned ? 'red ' : '') + (proMode ? 'checkBoxBorderedDK' : 'checkBoxBorderedLT')">
                                        <v-checkbox @change="calculateMDM" 
                                            style="height: 20px; margin-top: 8px;"
                                            v-model="mdmQaVal.worksheet.mdm.table_a.new_problem_workup_planned"
                                        ></v-checkbox>
                                    </v-col>
                                </v-row>
                                <!-- <v-row no-gutters >
                                    <v-col cols="12" :class="'text-body-2 py-2 pr-2 pl-4 ' + (proMode ? 'checkBoxBorderedDK' : 'checkBoxBorderedLT')">
                                        <p class="py-0 my-1 font-italic">Additional Work-Up Planned -- one of these three selections:</p>
                                        <p class="pl-2 my-1 font-italic">Admit/transfer/placed in observation</p>
                                        <p class="pl-2 my-1 font-italic">One or > special Study (CT, MRI, MRA, Ultrasound, Doppler Studies, V/Q scans)</p>
                                        <p class="pl-2 my-1 font-italic">Consultation with specialist in the ED or Consultation directly after discharge</p>
                                    </v-col>
                                </v-row> -->
                            </v-col>
                        </v-row>
                        <v-row no-gutters class="pb-2">
                            <v-col cols="12">
                                <v-row no-gutters class="pb-0">
                                    <v-col cols="12" :class="'text-center text-h6 ' + (proMode ? 'checkBoxBorderedDK' : 'checkBoxBorderedLT')">
                                        B. Data to Be Reviewed
                                        <v-tooltip max-width="350px" bottom v-if="worksheetsettings.labels && worksheetsettings.labels.mdm.table_b.header">
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-icon
                                                    color="primary"
                                                    :dark="proMode"
                                                    v-bind="attrs"
                                                    v-on="on"
                                                >
                                                    mdi-information-outline
                                                </v-icon>
                                            </template>
                                            <span>{{worksheetsettings.labels.mdm.table_b.header}}</span>
                                        </v-tooltip>
                                    </v-col>
                                </v-row>

                                <v-row no-gutters>
                                    <v-col cols="10" :class="'text-subtitle-2 text-center pa-2 ' + (proMode ? 'checkBoxBorderedDK' : 'checkBoxBorderedLT')">
                                        Option
                                    </v-col>
                                    <v-col :cols="(qaEnc ? 1 : 2)" :class="'text-subtitle-2 text-center pa-2 ' + (proMode ? 'checkBoxBorderedDK' : 'checkBoxBorderedLT')">
                                        {{(qaEnc ? 'QA' : 'TRUE?')}}
                                    </v-col>
                                    <v-col cols="1" v-if="qaEnc" :class="'text-subtitle-2 text-center pa-2 ' + (proMode ? 'checkBoxBorderedDK' : 'checkBoxBorderedLT')">
                                        Original
                                    </v-col>
                                </v-row>
                                <v-row no-gutters>
                                    <v-col cols="10" @click="(!readonly ? mdmVal.worksheet.mdm.table_b.review_order_of_clinical_lab_test = !mdmVal.worksheet.mdm.table_b.review_order_of_clinical_lab_test : '')" :class="'text-subtitle-1 pa-2 ' + (proMode ? 'checkBoxBorderedDK' : 'checkBoxBorderedLT')" :style="(readonly ? '' : 'cursor:pointer')">
                                        Review and/or order of laboratory test(s)
                                        <v-tooltip max-width="350px" bottom v-if="worksheetsettings.labels && worksheetsettings.labels.mdm.table_b.review_order_of_clinical_lab_test">
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-icon
                                                    color="primary"
                                                    :dark="proMode"
                                                    v-bind="attrs"
                                                    v-on="on"
                                                >
                                                    mdi-information-outline
                                                </v-icon>
                                            </template>
                                            <span>{{worksheetsettings.labels.mdm.table_b.review_order_of_clinical_lab_test}}</span>
                                        </v-tooltip>
                                    </v-col>
                                    <v-col :cols="(qaEnc ? 1 : 2)" :class="'text-center ' + (proMode ? 'checkBoxBorderedDK' : 'checkBoxBorderedLT')">
                                        <v-checkbox @change="calculateMDM" 
                                            style="height: 20px; margin-top: 8px;"
                                            v-model="mdmVal.worksheet.mdm.table_b.review_order_of_clinical_lab_test"
                                        ></v-checkbox>
                                    </v-col>
                                    <v-col v-if="qaEnc" cols="1" :class="'text-center ' + (mdmVal.worksheet.mdm.table_b.review_order_of_clinical_lab_test != mdmQaVal.worksheet.mdm.table_b.review_order_of_clinical_lab_test ? 'red ' : '') + (proMode ? 'checkBoxBorderedDK' : 'checkBoxBorderedLT')">
                                        <v-checkbox @change="calculateMDM" 
                                            style="height: 20px; margin-top: 8px;"
                                            v-model="mdmQaVal.worksheet.mdm.table_b.review_order_of_clinical_lab_test"
                                        ></v-checkbox>
                                    </v-col>
                                </v-row>
                                <v-row no-gutters>
                                    <v-col cols="10" @click="(!readonly ? mdmVal.worksheet.mdm.table_b.review_order_of_test_in_the_radiology_section_of_cpt = !mdmVal.worksheet.mdm.table_b.review_order_of_test_in_the_radiology_section_of_cpt : '')" :class="'text-subtitle-1 pa-2 ' + (proMode ? 'checkBoxBorderedDK' : 'checkBoxBorderedLT')" :style="(readonly ? '' : 'cursor:pointer')">
                                        Review and/or order of radiology test(s) (70010-79999)
                                        <v-tooltip max-width="350px" bottom v-if="worksheetsettings.labels && worksheetsettings.labels.mdm.table_b.review_order_of_test_in_the_radiology_section_of_cpt">
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-icon
                                                    color="primary"
                                                    :dark="proMode"
                                                    v-bind="attrs"
                                                    v-on="on"
                                                >
                                                    mdi-information-outline
                                                </v-icon>
                                            </template>
                                            <span>{{worksheetsettings.labels.mdm.table_b.review_order_of_test_in_the_radiology_section_of_cpt}}</span>
                                        </v-tooltip>
                                    </v-col>
                                    <v-col :cols="(qaEnc ? 1 : 2)" :class="'text-center ' + (proMode ? 'checkBoxBorderedDK' : 'checkBoxBorderedLT')">
                                        <v-checkbox @change="calculateMDM" 
                                            style="height: 20px; margin-top: 8px;"
                                            v-model="mdmVal.worksheet.mdm.table_b.review_order_of_test_in_the_radiology_section_of_cpt"
                                        ></v-checkbox>
                                    </v-col>
                                    <v-col v-if="qaEnc" cols="1" :class="'text-center ' + (mdmVal.worksheet.mdm.table_b.review_order_of_test_in_the_radiology_section_of_cpt != mdmQaVal.worksheet.mdm.table_b.review_order_of_test_in_the_radiology_section_of_cpt ? 'red ' : '') + (proMode ? 'checkBoxBorderedDK' : 'checkBoxBorderedLT')">
                                        <v-checkbox @change="calculateMDM" 
                                            style="height: 20px; margin-top: 8px;"
                                            v-model="mdmQaVal.worksheet.mdm.table_b.review_order_of_test_in_the_radiology_section_of_cpt"
                                        ></v-checkbox>
                                    </v-col>
                                </v-row>
                                <v-row no-gutters>
                                    <v-col cols="10" @click="(!readonly ? mdmVal.worksheet.mdm.table_b.review_order_of_test_in_the_medicine_section_of_cpt = !mdmVal.worksheet.mdm.table_b.review_order_of_test_in_the_medicine_section_of_cpt : '')" :class="'text-subtitle-1 pa-2 ' + (proMode ? 'checkBoxBorderedDK' : 'checkBoxBorderedLT')" :style="(readonly ? '' : 'cursor:pointer')">
                                        Review and/or order of tests in the medicine section of CPT (90900-99199)
                                        <v-tooltip max-width="350px" bottom v-if="worksheetsettings.labels && worksheetsettings.labels.mdm.table_b.review_order_of_test_in_the_medicine_section_of_cpt">
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-icon
                                                    color="primary"
                                                    :dark="proMode"
                                                    v-bind="attrs"
                                                    v-on="on"
                                                >
                                                    mdi-information-outline
                                                </v-icon>
                                            </template>
                                            <span>{{worksheetsettings.labels.mdm.table_b.review_order_of_test_in_the_medicine_section_of_cpt}}</span>
                                        </v-tooltip>
                                    </v-col>
                                    <v-col :cols="(qaEnc ? 1 : 2)" :class="'text-center ' + (proMode ? 'checkBoxBorderedDK' : 'checkBoxBorderedLT')">
                                        <v-checkbox @change="calculateMDM" 
                                            style="height: 20px; margin-top: 8px;"
                                            v-model="mdmVal.worksheet.mdm.table_b.review_order_of_test_in_the_medicine_section_of_cpt"
                                        ></v-checkbox>
                                    </v-col>
                                    <v-col v-if="qaEnc" cols="1" :class="'text-center ' + (mdmVal.worksheet.mdm.table_b.review_order_of_test_in_the_medicine_section_of_cpt != mdmQaVal.worksheet.mdm.table_b.review_order_of_test_in_the_medicine_section_of_cpt ? 'red ' : '') + (proMode ? 'checkBoxBorderedDK' : 'checkBoxBorderedLT')">
                                        <v-checkbox @change="calculateMDM" 
                                            style="height: 20px; margin-top: 8px;"
                                            v-model="mdmQaVal.worksheet.mdm.table_b.review_order_of_test_in_the_medicine_section_of_cpt"
                                        ></v-checkbox>
                                    </v-col>
                                </v-row>
                                <v-row no-gutters>
                                    <v-col cols="10" @click="(!readonly ? mdmVal.worksheet.mdm.table_b.discussion_of_test_results_with_performing_physician = !mdmVal.worksheet.mdm.table_b.discussion_of_test_results_with_performing_physician : '')" :class="'text-subtitle-1 pa-2 ' + (proMode ? 'checkBoxBorderedDK' : 'checkBoxBorderedLT')" :style="(readonly ? '' : 'cursor:pointer')">
                                        Discuss tests/review with another physician
                                        <v-tooltip max-width="350px" bottom v-if="worksheetsettings.labels && worksheetsettings.labels.mdm.table_b.discussion_of_test_results_with_performing_physician">
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-icon
                                                    color="primary"
                                                    :dark="proMode"
                                                    v-bind="attrs"
                                                    v-on="on"
                                                >
                                                    mdi-information-outline
                                                </v-icon>
                                            </template>
                                            <span>{{worksheetsettings.labels.mdm.table_b.discussion_of_test_results_with_performing_physician}}</span>
                                        </v-tooltip>
                                    </v-col>
                                    <v-col :cols="(qaEnc ? 1 : 2)" :class="'text-center ' + (proMode ? 'checkBoxBorderedDK' : 'checkBoxBorderedLT')">
                                        <v-checkbox @change="calculateMDM" 
                                            style="height: 20px; margin-top: 8px;"
                                            v-model="mdmVal.worksheet.mdm.table_b.discussion_of_test_results_with_performing_physician"
                                        ></v-checkbox>
                                    </v-col>
                                    <v-col v-if="qaEnc" cols="1" :class="'text-center ' + (mdmVal.worksheet.mdm.table_b.discussion_of_test_results_with_performing_physician != mdmQaVal.worksheet.mdm.table_b.discussion_of_test_results_with_performing_physician ? 'red ' : '') + (proMode ? 'checkBoxBorderedDK' : 'checkBoxBorderedLT')">
                                        <v-checkbox @change="calculateMDM" 
                                            style="height: 20px; margin-top: 8px;"
                                            v-model="mdmQaVal.worksheet.mdm.table_b.discussion_of_test_results_with_performing_physician"
                                        ></v-checkbox>
                                    </v-col>
                                </v-row>
                                <v-row no-gutters>
                                    <v-col cols="10" @click="(!readonly ? mdmVal.worksheet.mdm.table_b.decision_to_obtain_old_records_history_from_someone_other_than_patient = !mdmVal.worksheet.mdm.table_b.decision_to_obtain_old_records_history_from_someone_other_than_patient : '')" :class="'text-subtitle-1 pa-2 ' + (proMode ? 'checkBoxBorderedDK' : 'checkBoxBorderedLT')" :style="(readonly ? '' : 'cursor:pointer')">
                                        Decision to obtain old records/History from other source
                                        <v-tooltip max-width="350px" bottom v-if="worksheetsettings.labels && worksheetsettings.labels.mdm.table_b.decision_to_obtain_old_records_history_from_someone_other_than_patient">
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-icon
                                                    color="primary"
                                                    :dark="proMode"
                                                    v-bind="attrs"
                                                    v-on="on"
                                                >
                                                    mdi-information-outline
                                                </v-icon>
                                            </template>
                                            <span>{{worksheetsettings.labels.mdm.table_b.decision_to_obtain_old_records_history_from_someone_other_than_patient}}</span>
                                        </v-tooltip>
                                    </v-col>
                                    <v-col :cols="(qaEnc ? 1 : 2)" :class="'text-center ' + (proMode ? 'checkBoxBorderedDK' : 'checkBoxBorderedLT')">
                                        <v-checkbox @change="calculateMDM" 
                                            style="height: 20px; margin-top: 8px;"
                                            v-model="mdmVal.worksheet.mdm.table_b.decision_to_obtain_old_records_history_from_someone_other_than_patient"
                                        ></v-checkbox>
                                    </v-col>
                                    <v-col v-if="qaEnc" cols="1" :class="'text-center ' + (mdmVal.worksheet.mdm.table_b.decision_to_obtain_old_records_history_from_someone_other_than_patient != mdmQaVal.worksheet.mdm.table_b.decision_to_obtain_old_records_history_from_someone_other_than_patient ? 'red ' : '') + (proMode ? 'checkBoxBorderedDK' : 'checkBoxBorderedLT')">
                                        <v-checkbox @change="calculateMDM" 
                                            style="height: 20px; margin-top: 8px;"
                                            v-model="mdmQaVal.worksheet.mdm.table_b.decision_to_obtain_old_records_history_from_someone_other_than_patient"
                                        ></v-checkbox>
                                    </v-col>
                                </v-row>
                                <v-row no-gutters>
                                    <v-col cols="10" @click="(!readonly ? mdmVal.worksheet.mdm.table_b.review_and_summarization_of_old_records_obtaining_history_from_someone_other_than_patient_discussion_of_case_with_another_healthcare_provider = !mdmVal.worksheet.mdm.table_b.review_and_summarization_of_old_records_obtaining_history_from_someone_other_than_patient_discussion_of_case_with_another_healthcare_provider : '')" :class="'text-subtitle-1 pa-2 ' + (proMode ? 'checkBoxBorderedDK' : 'checkBoxBorderedLT')" :style="(readonly ? '' : 'cursor:pointer')">
                                        Review and summarization of old records and/or obtaining history from someone other than patient and/or discussion of case with another health care provider (consult/transfer/admit/psych/social worker/EMS/poison control)
                                        <v-tooltip max-width="350px" bottom v-if="worksheetsettings.labels && worksheetsettings.labels.mdm.table_b.review_and_summarization_of_old_records_obtaining_history_from_someone_other_than_patient_discussion_of_case_with_another_healthcare_provider">
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-icon
                                                    color="primary"
                                                    :dark="proMode"
                                                    v-bind="attrs"
                                                    v-on="on"
                                                >
                                                    mdi-information-outline
                                                </v-icon>
                                            </template>
                                            <span>{{worksheetsettings.labels.mdm.table_b.review_and_summarization_of_old_records_obtaining_history_from_someone_other_than_patient_discussion_of_case_with_another_healthcare_provider}}</span>
                                        </v-tooltip>
                                    </v-col>
                                    <v-col :cols="(qaEnc ? 1 : 2)" :class="'text-center ' + (proMode ? 'checkBoxBorderedDK' : 'checkBoxBorderedLT')">
                                        <v-checkbox @change="calculateMDM" 
                                            style="height: 20px; margin-top: 8px;"
                                            v-model="mdmVal.worksheet.mdm.table_b.review_and_summarization_of_old_records_obtaining_history_from_someone_other_than_patient_discussion_of_case_with_another_healthcare_provider"
                                        ></v-checkbox>
                                    </v-col>
                                    <v-col v-if="qaEnc" cols="1" :class="'text-center ' + (mdmVal.worksheet.mdm.table_b.review_and_summarization_of_old_records_obtaining_history_from_someone_other_than_patient_discussion_of_case_with_another_healthcare_provider != mdmQaVal.worksheet.mdm.table_b.review_and_summarization_of_old_records_obtaining_history_from_someone_other_than_patient_discussion_of_case_with_another_healthcare_provider ? 'red ' : '') + (proMode ? 'checkBoxBorderedDK' : 'checkBoxBorderedLT')">
                                        <v-checkbox @change="calculateMDM" 
                                            style="height: 20px; margin-top: 8px;"
                                            v-model="mdmQaVal.worksheet.mdm.table_b.review_and_summarization_of_old_records_obtaining_history_from_someone_other_than_patient_discussion_of_case_with_another_healthcare_provider"
                                        ></v-checkbox>
                                    </v-col>
                                </v-row>
                                <v-row no-gutters>
                                    <v-col cols="10" @click="(!readonly ? mdmVal.worksheet.mdm.table_b.independent_visualization_of_image_tracing_or_specimen_itself = !mdmVal.worksheet.mdm.table_b.independent_visualization_of_image_tracing_or_specimen_itself : '')" :class="'text-subtitle-1 pa-2 ' + (proMode ? 'checkBoxBorderedDK' : 'checkBoxBorderedLT')" :style="(readonly ? '' : 'cursor:pointer')">
                                        Independent visualization/interpretation of image, tracing, specimen
                                        <v-tooltip max-width="350px" bottom v-if="worksheetsettings.labels && worksheetsettings.labels.mdm.table_b.independent_visualization_of_image_tracing_or_specimen_itself">
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-icon
                                                    color="primary"
                                                    :dark="proMode"
                                                    v-bind="attrs"
                                                    v-on="on"
                                                >
                                                    mdi-information-outline
                                                </v-icon>
                                            </template>
                                            <span>{{worksheetsettings.labels.mdm.table_b.independent_visualization_of_image_tracing_or_specimen_itself}}</span>
                                        </v-tooltip>
                                    </v-col>
                                    <v-col :cols="(qaEnc ? 1 : 2)" :class="'text-center ' + (proMode ? 'checkBoxBorderedDK' : 'checkBoxBorderedLT')">
                                        <v-checkbox @change="calculateMDM" 
                                            style="height: 20px; margin-top: 8px;"
                                            v-model="mdmVal.worksheet.mdm.table_b.independent_visualization_of_image_tracing_or_specimen_itself"
                                        ></v-checkbox>
                                    </v-col>
                                    <v-col v-if="qaEnc" cols="1" :class="'text-center ' + (mdmVal.worksheet.mdm.table_b.independent_visualization_of_image_tracing_or_specimen_itself != mdmQaVal.worksheet.mdm.table_b.independent_visualization_of_image_tracing_or_specimen_itself ? 'red ' : '') + (proMode ? 'checkBoxBorderedDK' : 'checkBoxBorderedLT')">
                                        <v-checkbox @change="calculateMDM" 
                                            style="height: 20px; margin-top: 8px;"
                                            v-model="mdmQaVal.worksheet.mdm.table_b.independent_visualization_of_image_tracing_or_specimen_itself"
                                        ></v-checkbox>
                                    </v-col>
                                </v-row>


                            </v-col>
                        </v-row>
                        <v-row no-gutters class="pb-2">
                            <v-col cols="12">
                                <v-row no-gutters class="pb-0">
                                    <v-col cols="12" :class="'text-center text-h6 ' + (proMode ? 'checkBoxBorderedDK' : 'checkBoxBorderedLT')">
                                        C. Presenting Problem/Management Options
                                        <v-tooltip max-width="350px" bottom v-if="worksheetsettings.labels && worksheetsettings.labels.mdm.table_c.header">
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-icon
                                                    color="primary"
                                                    :dark="proMode"
                                                    v-bind="attrs"
                                                    v-on="on"
                                                >
                                                    mdi-information-outline
                                                </v-icon>
                                            </template>
                                            <span>{{worksheetsettings.labels.mdm.table_c.header}}</span>
                                        </v-tooltip>
                                    </v-col>
                                </v-row>

                                <v-row no-gutters>
                                    <v-col cols="6" :class="'text-subtitle-2 text-center pa-2 ' + (proMode ? 'checkBoxBorderedDK' : 'checkBoxBorderedLT')">
                                        Presenting Problem
                                    </v-col>
                                    <v-col cols="4" :class="'text-subtitle-2 text-center pa-2 ' + (proMode ? 'checkBoxBorderedDK' : 'checkBoxBorderedLT')">
                                        Management Options
                                    </v-col>
                                    <v-col :cols="(qaEnc ? 1 : 2)" :class="'text-subtitle-2 text-center pa-2 ' + (proMode ? 'checkBoxBorderedDK' : 'checkBoxBorderedLT')">
                                        {{(qaEnc ? 'QA' : 'RISK')}}
                                    </v-col>
                                    <v-col cols="1" v-if="qaEnc" :class="'text-subtitle-2 text-center pa-2 ' + (proMode ? 'checkBoxBorderedDK' : 'checkBoxBorderedLT')">
                                        Original
                                    </v-col>
                                    
                                </v-row>
                                <v-row no-gutters>
                                    <v-col cols="6" @click="(!readonly ? mdmVal.worksheet.mdm.table_c.minimal = !mdmVal.worksheet.mdm.table_c.minimal : '')" :class="'text-subtitle-1 pa-2 ' + (proMode ? 'checkBoxBorderedDK' : 'checkBoxBorderedLT')" :style="(readonly ? '' : 'cursor:pointer')">
                                        <p class="py-0 my-1">No ancillary studies.</p>
                                        <p class="py-0 my-1">No meds in ED unless the patient requests</p>
                                        <p class="py-0 my-1">Tetanus</p>
                                        <p class="py-0 my-1">No Rx on discharge</p>
                                    </v-col>
                                    <v-col cols="4" @click="(!readonly ? mdmVal.worksheet.mdm.table_c.minimal = !mdmVal.worksheet.mdm.table_c.minimal : '')" :class="'text-subtitle-1 pa-2 ' + (proMode ? 'checkBoxBorderedDK' : 'checkBoxBorderedLT')" :style="(readonly ? '' : 'cursor:pointer')">
                                        <p class="py-0 my-1">Usually recheck visits with isolated exam.</p>
                                        <p class="py-0 my-1">Suture removal for patient treated at another facility.</p>
                                        <p class="py-0 my-1">Patient requests tetanus only</p>
                                    </v-col>
                                    <v-col :cols="(qaEnc ? 1 : 2)" :class="'text-center ' + (proMode ? 'checkBoxBorderedDK' : 'checkBoxBorderedLT')">
                                        <v-checkbox @change="calculateMDM" 
                                            style="height: 20px; margin-top: 8px;"
                                            label="Minimal"
                                            v-model="mdmVal.worksheet.mdm.table_c.minimal"
                                        ></v-checkbox>
                                    </v-col>
                                    <v-col v-if="qaEnc" cols="1" :class="'text-center ' + (mdmVal.worksheet.mdm.table_c.minimal != mdmQaVal.worksheet.mdm.table_c.minimal ? 'red ' : '') + (proMode ? 'checkBoxBorderedDK' : 'checkBoxBorderedLT')">
                                        <v-checkbox @change="calculateMDM" 
                                            style="height: 20px; margin-top: 8px;"
                                            label="Minimal"
                                            v-model="mdmQaVal.worksheet.mdm.table_c.minimal"
                                        ></v-checkbox>
                                    </v-col>
                                </v-row>

                                <v-row no-gutters>
                                    <v-col cols="6" @click="(!readonly ? mdmVal.worksheet.mdm.table_c.low = !mdmVal.worksheet.mdm.table_c.low : '')" :class="'text-subtitle-1 pa-2 ' + (proMode ? 'checkBoxBorderedDK' : 'checkBoxBorderedLT')" :style="(readonly ? '' : 'cursor:pointer')">
                                        <p class="py-0 my-1">No ancillary studies.</p>
                                        <p class="py-0 my-1">No meds in ED.</p>
                                        <p class="py-0 my-1">No Rx on discharge</p>
                                        <p class="py-0 my-1">No consultations.</p>
                                        <p class="py-0 my-1">Crutch Training</p>
                                        <p class="py-0 my-1">At discharge, instructions to purchase OTC meds.</p>
                                    </v-col>
                                    <v-col cols="4" @click="(!readonly ? mdmVal.worksheet.mdm.table_c.low = !mdmVal.worksheet.mdm.table_c.low : '')" :class="'text-subtitle-1 pa-2 ' + (proMode ? 'checkBoxBorderedDK' : 'checkBoxBorderedLT')" :style="(readonly ? '' : 'cursor:pointer')">
                                        <p class="py-0 my-1">1. Exam may be isolated to head, chest and abdomen (no Neuro,</p>
                                        <p class="py-0 my-1">pelvic, rectal or external genitalia exam).</p>
                                        <p class="py-0 my-1">2. Local exam of body area(s).</p>
                                        <p class="py-0 my-1">3. Superficial Trauma w/out an x-ray ordered, (straightforward</p>
                                        <p class="py-0 my-1">mechanism of injury, i.e. simple finger laceration (steri-strips)</p>
                                        <p class="py-0 my-1">4. Check visual acuity.</p>
                                    </v-col>
                                    <v-col :cols="(qaEnc ? 1 : 2)" :class="'text-center ' + (proMode ? 'checkBoxBorderedDK' : 'checkBoxBorderedLT')">
                                        <v-checkbox @change="calculateMDM" 
                                            style="height: 20px; margin-top: 8px;"
                                            label="Low"
                                            v-model="mdmVal.worksheet.mdm.table_c.low"
                                        ></v-checkbox>
                                    </v-col>
                                    <v-col v-if="qaEnc" cols="1" :class="'text-center ' + (mdmVal.worksheet.mdm.table_c.low != mdmQaVal.worksheet.mdm.table_c.low ? 'red ' : '') + (proMode ? 'checkBoxBorderedDK' : 'checkBoxBorderedLT')">
                                        <v-checkbox @change="calculateMDM" 
                                            style="height: 20px; margin-top: 8px;"
                                            label="Low"
                                            v-model="mdmQaVal.worksheet.mdm.table_c.low"
                                        ></v-checkbox>
                                    </v-col>
                                </v-row>

                                <v-row no-gutters>
                                    <v-col cols="6" @click="(!readonly ? mdmVal.worksheet.mdm.table_c.low_moderate = !mdmVal.worksheet.mdm.table_c.low_moderate : '')" :class="'text-subtitle-1 pa-2 ' + (proMode ? 'checkBoxBorderedDK' : 'checkBoxBorderedLT')" :style="(readonly ? '' : 'cursor:pointer')">
                                        <p class="py-0 my-1">1. Fleet's™ enema or digital disimpaction.</p>
                                        <p class="py-0 my-1">2. Urinary or Foley™ catheter for urine sample</p>
                                        <p class="py-0 my-1">or output determination.</p>
                                        <p class="py-0 my-1">3. Evaluate, change or replace tracheotomy,</p>
                                        <p class="py-0 my-1">gastrostomy, ileostomy or cystostomy</p>
                                        <p class="py-0 my-1">tube(s).</p>
                                        <p class="py-0 my-1">4. Documented call or on-site consultation</p>
                                        <p class="py-0 my-1">with PCP, referral physician, social worker, or</p>
                                        <p class="py-0 my-1">poison control but not psych related.</p>
                                        <p class="py-0 my-1">5. Oral, eye, ear, nasal, or rectal meds given in</p>
                                        <p class="py-0 my-1">ED (includes OTC meds). Excluding oral</p>
                                        <p class="py-0 my-1">medications used as Conscious Sedation, for</p>
                                        <p class="py-0 my-1">example, PO Versed.</p>
                                        <p class="py-0 my-1">6. Topical meds specifically ordered by the</p>
                                        <p class="py-0 my-1">provider (e.g., Neosporin, Silvadene,</p>
                                        <p class="py-0 my-1">Bacitracin, Polymycin) excluding topical</p>
                                        <p class="py-0 my-1">anesthetics such as LET, TAC and EMLA).</p>
                                        <p class="py-0 my-1">7. Any Rx at DC whether OTC, non-OTC or</p>
                                        <p class="py-0 my-1">controlled.</p>
                                        <p class="py-0 my-1">8. Laceration Repair with sutures</p>
                                        <p class="py-0 my-1">9. Isolated IM or subcutaneous injection (noncontrolled)</p>
                                        <p class="py-0 my-1">without ancillary studies or oral,</p>
                                        <p class="py-0 my-1">rectal, eye, ear, nasal or topical meds in ED.</p>
                                        <p class="py-0 my-1">10. One (1) set of x-rays to an isolated area</p>
                                        <p class="py-0 my-1">(CXR, hip/pelvis, shoulder or C-spine alone)</p>
                                        <p class="py-0 my-1">or > one (1) set of adjacent x-rays for distal</p>
                                        <p class="py-0 my-1">extremities (hand/wrist, foot/ankle).</p>
                                        <p class="py-0 my-1">11. One (1) to three (3) ancillary studies (lab</p>
                                        <p class="py-0 my-1">and/or x-ray) (not within the same</p>
                                        <p class="py-0 my-1">department) ordered and may include</p>
                                        <p class="py-0 my-1">bedside studies (UA, UCG, AccuCheck).</p>
                                        <p class="py-0 my-1">12. Eye exam with fluorescein stain or slit lamp.</p>
                                        <p class="py-0 my-1">13. Provider reviews/adjusts current patient</p>
                                        <p class="py-0 my-1">meds (drug reconciliation with signature).</p>
                                        <p class="py-0 my-1">14. Doppler studies to hear the pulse and/or</p>
                                        <p class="py-0 my-1">FHTs (Fetal Heart Tones) during pregnancy.</p>
                                        <p class="py-0 my-1">15. One (1) nebulizer (with one (1) medication).</p>
                                        <p class="py-0 my-1">16. Placement of patient on oxygen (nasal or</p>
                                        <p class="py-0 my-1">mask).</p>
                                    </v-col>
                                    <v-col cols="4" @click="(!readonly ? mdmVal.worksheet.mdm.table_c.low_moderate = !mdmVal.worksheet.mdm.table_c.low_moderate : '')" :class="'text-subtitle-1 pa-2 ' + (proMode ? 'checkBoxBorderedDK' : 'checkBoxBorderedLT')" :style="(readonly ? '' : 'cursor:pointer')">
                                        <p class="py-0 my-1">1. Multiple presenting complaints.</p>
                                        <p class="py-0 my-1">2. Pregnant patient with any complaint.</p>
                                        <p class="py-0 my-1">3. Non-trauma patients who present via ambulance or EMS.</p>
                                        <p class="py-0 my-1">4. Fever</p>
                                        <p class="py-0 my-1">5. A condition that requires an exam of head, chest and abdomen</p>
                                        <p class="py-0 my-1">with a neurological exam added. (some examples: head, scalp</p>
                                        <p class="py-0 my-1">or facial trauma, extremity laceration with possible nerve</p>
                                        <p class="py-0 my-1">damage, dizziness, abnormal gait, headache, mentation and/or</p>
                                        <p class="py-0 my-1">coordination change) Please note: a neurological exam may</p>
                                        <p class="py-0 my-1">include any of the following statements in the exam section of</p>
                                        <p class="py-0 my-1">chart:</p>
                                        <p class="py-0 my-1">General/Constitutional: Awake, Alert, Oriented times 3</p>
                                        <p class="py-0 my-1">Eyes: PERLA, EOM intact.</p>
                                        <p class="py-0 my-1">Musculoskeletal: Extremity strength, motion, and sensation</p>
                                        <p class="py-0 my-1">(e.g., N/V intact, strength 4/5, strength symmetrical)</p>
                                        <p class="py-0 my-1">Neuro: CN 2-12 intact, DTRs intact. Babinski, Kernig's and</p>
                                        <p class="py-0 my-1">cerebellar findings.</p>
                                        <p class="py-0 my-1">6. Pelvic, rectal, breast and/or external genitalia exam on patient</p>
                                        <p class="py-0 my-1">w/out abdominal pain.</p>
                                        <p class="py-0 my-1">7. Gastroenteritis type case (nausea, vomiting, diarrhea with +/-</p>
                                        <p class="py-0 my-1">abdominal cramping) with no therapy in ED.</p>
                                        <p class="py-0 my-1">8. Vaginal discharge with no abdominal pain.</p>
                                        <p class="py-0 my-1">9. Constipated or fecal impaction requiring a Fleet's™ enema or</p>
                                        <p class="py-0 my-1">digital disimpaction.</p>
                                        <p class="py-0 my-1">10. Need for urine sample or urine output measurement and order</p>
                                        <p class="py-0 my-1">insertion of urinary or Foley™ catheter.</p>
                                        <p class="py-0 my-1">11. Re-examination by provider.</p>
                                        <p class="py-0 my-1">12. Non-cardiac chest pain with CXR and no EKG.</p>
                                        <p class="py-0 my-1">13. Trauma with one (1) set of x-rays or select adjacent x-ray series</p>
                                        <p class="py-0 my-1">(i.e. ankle/foot, hip/pelvis and wrist/hand only).</p>
                                        <p class="py-0 my-1">14. Psych evaluation by ED provider with no request for psych</p>
                                        <p class="py-0 my-1">professional evaluation (stable anxiety, depression, bipolar</p>
                                        <p class="py-0 my-1">may/ may not be off meds).</p>
                                    </v-col>
                                    <v-col :cols="(qaEnc ? 1 : 2)" :class="'text-center ' + (proMode ? 'checkBoxBorderedDK' : 'checkBoxBorderedLT')">
                                        <v-checkbox @change="calculateMDM" 
                                            style="height: 20px; margin-top: 8px;"
                                            label="Low Moderate"
                                            v-model="mdmVal.worksheet.mdm.table_c.low_moderate"
                                        ></v-checkbox>
                                    </v-col>
                                    <v-col v-if="qaEnc" cols="1" :class="'text-center ' + (mdmVal.worksheet.mdm.table_c.low_moderate != mdmQaVal.worksheet.mdm.table_c.low_moderate ? 'red ' : '') + (proMode ? 'checkBoxBorderedDK' : 'checkBoxBorderedLT')">
                                        <v-checkbox @change="calculateMDM" 
                                            style="height: 20px; margin-top: 8px;"
                                            label="Low Moderate"
                                            v-model="mdmQaVal.worksheet.mdm.table_c.low_moderate"
                                        ></v-checkbox>
                                    </v-col>
                                </v-row>

                                <v-row no-gutters>
                                    <v-col cols="6" @click="(!readonly ? mdmVal.worksheet.mdm.table_c.high_moderate = !mdmVal.worksheet.mdm.table_c.high_moderate : '')" :class="'text-subtitle-1 pa-2 ' + (proMode ? 'checkBoxBorderedDK' : 'checkBoxBorderedLT')" :style="(readonly ? '' : 'cursor:pointer')">
                                        <p class="py-0 my-1">1. Urinary or Foley™ catheter for urinary</p>
                                        <p class="py-0 my-1">retention.</p>
                                        <p class="py-0 my-1">2. Psych consultation in ED. (i.e. PET, social</p>
                                        <p class="py-0 my-1">worker, etc.).</p>
                                        <p class="py-0 my-1">3. Four (4) or > ancillary departmental studies</p>
                                        <p class="py-0 my-1">(lab or x-ray).</p>
                                        <p class="py-0 my-1">4. Two (2) to three (3) x-ray series on nonadjacent</p>
                                        <p class="py-0 my-1">sites (shoulder/elbow;</p>
                                        <p class="py-0 my-1">forearm/hand; knee/elbow).</p>
                                        <p class="py-0 my-1">5. Multiple spine series x-rays</p>
                                        <p class="py-0 my-1">(cervical/thoracic; lumbar/cervical; etc.).</p>
                                        <p class="py-0 my-1">6. Cultures: wound/abscess, blood, urine,</p>
                                        <p class="py-0 my-1">sputum, stool. (Throat cultures do not</p>
                                        <p class="py-0 my-1">apply to this MDM category).</p>
                                        <p class="py-0 my-1">7. Isolated EKG alone.</p>
                                        <p class="py-0 my-1">8. One (1) Special Study (CT, MRI or MRA,</p>
                                        <p class="py-0 my-1">Ultrasound, Doppler studies, V/Q scans).</p>
                                        <p class="py-0 my-1">9. IV Fluids.</p>
                                        <p class="py-0 my-1">10. IV meds isolated or multiple (< three (3) if</p>
                                        <p class="py-0 my-1">non-controlled and one (1) if controlled).</p>
                                        <p class="py-0 my-1">11. Two (2) IM meds non-controlled.</p>
                                        <p class="py-0 my-1">12. IM with one (1) controlled substance</p>
                                        <p class="py-0 my-1">(Demerol, Dilaudid, Morphine, Fentanyl™,</p>
                                        <p class="py-0 my-1">Ativan™, Valium™).</p>
                                        <p class="py-0 my-1">13. IM med with any ancillary studies (lab or xray).</p>
                                        <p class="py-0 my-1">14. IM meds with oral, rectal, eye, ear, nasal or</p>
                                        <p class="py-0 my-1">topical meds given in ED.</p>
                                        <p class="py-0 my-1">15. IM med with one (1) or more nebulizer</p>
                                        <p class="py-0 my-1">treatment(s).</p>
                                        <p class="py-0 my-1">16. Moderate sedation with one (1) or two (2)</p>
                                        <p class="py-0 my-1">ancillary studies and no Special Study. This</p>
                                        <p class="py-0 my-1">included PO Versed or other controlled</p>
                                        <p class="py-0 my-1">substance given orally with monitoring.</p>
                                        <p class="py-0 my-1">17. Multiple (2 or >) nebulizer or two (2) meds</p>
                                        <p class="py-0 my-1">in one (1) nebulizer/Duoneb or continuous</p>
                                        <p class="py-0 my-1">nebulizer.</p>
                                        <p class="py-0 my-1">18. ABG ordered alone w/out interpretation.</p>
                                        <p class="py-0 my-1">19. Three (3) or more of the following:</p>
                                        <p class="py-0 my-1">• Temp ≥ 101.4oF</p>
                                        <p class="py-0 my-1">• Ancillary 1 or more studies lab</p>
                                        <p class="py-0 my-1">• Ancillary 1 or more studies x-ray</p>
                                        <p class="py-0 my-1">• Meds in ED (Td does not apply)</p>
                                        <p class="py-0 my-1">• Rx on D/C (not an RX for an OTC)</p>
                                        <p class="py-0 my-1">• Consultation in the ED</p>
                                        <p class="py-0 my-1">• Conversation with another provider</p>
                                        <p class="py-0 my-1">(does not apply to supervising</p>
                                        <p class="py-0 my-1">physician).</p>
                                        <p class="py-0 my-1">• PICC line flush</p>
                                        <p class="py-0 my-1">• G tube evaluation/flush/change</p>
                                        <p class="py-0 my-1">• Foley catheter evaluation/flush/change</p>
                                    </v-col>
                                    <v-col cols="4" @click="(!readonly ? mdmVal.worksheet.mdm.table_c.high_moderate = !mdmVal.worksheet.mdm.table_c.high_moderate : '')" :class="'text-subtitle-1 pa-2 ' + (proMode ? 'checkBoxBorderedDK' : 'checkBoxBorderedLT')" :style="(readonly ? '' : 'cursor:pointer')">
                                        <p class="py-0 my-1">1. Trauma patients who arrive via EMS (On backboard and/or in</p>
                                        <p class="py-0 my-1">C-collar).</p>
                                        <p class="py-0 my-1">2. Isolated hip/pelvis fracture with no other ancillaries or</p>
                                        <p class="py-0 my-1">medications in the ED prior to admission.</p>
                                        <p class="py-0 my-1">3. Extremity injury admitted for surgical repair (nerve or tendon</p>
                                        <p class="py-0 my-1">laceration fracture).</p>
                                        <p class="py-0 my-1">4. Head injury with brief LOC, dizziness, severe headache, nausea or</p>
                                        <p class="py-0 my-1">vomiting.</p>
                                        <p class="py-0 my-1">5. Psych patients with psych consultation (social services or psych),</p>
                                        <p class="py-0 my-1">no ancillary studies, and discharged.</p>
                                        <p class="py-0 my-1">6. Psych related conditions with voluntary admission w/out any lab,</p>
                                        <p class="py-0 my-1">x-ray or special studies ordered and no medications given.</p>
                                        <p class="py-0 my-1">7. Chest pain with workup that may include EKG, CXR, multiple labs</p>
                                        <p class="py-0 my-1">w/out cardiac enzymes w/out visualization or interpretation of</p>
                                        <p class="py-0 my-1">EKG and CXR.</p>
                                        <p class="py-0 my-1">8. Abdominal pain with one of the following:</p>
                                        <p class="py-0 my-1">Pelvic or rectal exam.</p>
                                        <p class="py-0 my-1">Four (4) or > ancillary studies.</p>
                                        <p class="py-0 my-1">9. Flank pain or kidney stone evaluations with lab workup w/out CT</p>
                                        <p class="py-0 my-1">abdomen/pelvis.</p>
                                        <p class="py-0 my-1">10. Shortness of breath, wheezing, difficulty breathing with two (2</p>
                                        <p class="py-0 my-1">or > nebulizer treatments.</p>
                                        <p class="py-0 my-1">11. Urinary retention with need for urinary or Foley catheter</p>
                                        <p class="py-0 my-1">insertion.</p>
                                        <p class="py-0 my-1">12. Spontaneous abortion.</p>
                                    </v-col>
                                    <v-col :cols="(qaEnc ? 1 : 2)" :class="'text-center ' + (proMode ? 'checkBoxBorderedDK' : 'checkBoxBorderedLT')">
                                        <v-checkbox @change="calculateMDM" 
                                            style="height: 20px; margin-top: 8px;"
                                            label="High Moderate"
                                            v-model="mdmVal.worksheet.mdm.table_c.high_moderate"
                                        ></v-checkbox>
                                    </v-col>
                                    <v-col v-if="qaEnc" cols="1" :class="'text-center ' + (mdmVal.worksheet.mdm.table_c.high_moderate != mdmQaVal.worksheet.mdm.table_c.high_moderate ? 'red ' : '') + (proMode ? 'checkBoxBorderedDK' : 'checkBoxBorderedLT')">
                                        <v-checkbox @change="calculateMDM" 
                                            style="height: 20px; margin-top: 8px;"
                                            label="High Moderate"
                                            v-model="mdmQaVal.worksheet.mdm.table_c.high_moderate"
                                        ></v-checkbox>
                                    </v-col>
                                </v-row>

                                <v-row no-gutters>
                                    <v-col cols="6" @click="(!readonly ? mdmVal.worksheet.mdm.table_c.high = !mdmVal.worksheet.mdm.table_c.high : '')" :class="'text-subtitle-1 pa-2 ' + (proMode ? 'checkBoxBorderedDK' : 'checkBoxBorderedLT')" :style="(readonly ? '' : 'cursor:pointer')">
                                        <p class="py-0 my-1">1. Two (2) or > Special Studies (CT, US, MRI,</p>
                                        <p class="py-0 my-1">MRA, VQ Scan, Arteriogram) whether</p>
                                        <p class="py-0 my-1">trauma or medical complaint.</p>
                                        <p class="py-0 my-1">2. Four (4) or > sets of x-rays.</p>
                                        <p class="py-0 my-1">3. Three (3) or > ancillary studies with</p>
                                        <p class="py-0 my-1">visualization of EKG, x-ray or Special Study.</p>
                                        <p class="py-0 my-1">4. Moderate sedation with three (3) or ></p>
                                        <p class="py-0 my-1">ancillaries or a Special Study.</p>
                                        <p class="py-0 my-1">5. Two (2) or > IV or IM controlled meds with</p>
                                        <p class="py-0 my-1">three (3) or > ancillaries or a Special Study.</p>
                                        <p class="py-0 my-1">6. Three (3) or > IV or IM (controlled or noncontrolled)</p>
                                        <p class="py-0 my-1">meds with three (3) or ></p>
                                        <p class="py-0 my-1">ancillaries or a Special Study.</p>
                                        <p class="py-0 my-1">7. Ordering blood or blood products (packed</p>
                                        <p class="py-0 my-1">cells, FFP, platelets, Factor VIII, albumen).</p>
                                        <p class="py-0 my-1">8. Combination of IV Fluids, any IV or IM meds</p>
                                        <p class="py-0 my-1">(TD not counted), three (3) or ></p>
                                        <p class="py-0 my-1">departmental ancillary studies and Special</p>
                                        <p class="py-0 my-1">Study for any presenting problem.</p>
                                        <p class="py-0 my-1">9. Procedures done on high acuity patient</p>
                                        <p class="py-0 my-1">with stable vitals: LP, NG, Triple lumen</p>
                                        <p class="py-0 my-1">catheter, Thoracentesis, Chest tube.</p>
                                        <p class="py-0 my-1">10. Most admissions, transfers; those who have</p>
                                        <p class="py-0 my-1">expired or are directly sent to OR from ED.</p>
                                        <p class="py-0 my-1">(Excluding minimal workup direct admits).</p>
                                        <p class="py-0 my-1">11. Critical Care type patients who do not have</p>
                                        <p class="py-0 my-1">30 minutes or greater CC time documented</p>
                                        <p class="py-0 my-1">on the chart.</p>
                                        <p class="py-0 my-1">12. Work up and data review at four points</p>
                                        <p class="py-0 my-1">apiece (refer to Table A and B on page 9 of</p>
                                        <p class="py-0 my-1">this document).</p>
                                        <p class="py-0 my-1">13. Four (4) or > ancillary departmental studies</p>
                                        <p class="py-0 my-1">plus one of the following: ABGs, blood</p>
                                        <p class="py-0 my-1">culture or blood products along with any</p>
                                        <p class="py-0 my-1">therapeutic intervention (IV fluids, IV or IM</p>
                                        <p class="py-0 my-1">meds, and/or one or more nebulizers).</p>
                                    </v-col>
                                    <v-col cols="4" @click="(!readonly ? mdmVal.worksheet.mdm.table_c.high = !mdmVal.worksheet.mdm.table_c.high : '')" :class="'text-subtitle-1 pa-2 ' + (proMode ? 'checkBoxBorderedDK' : 'checkBoxBorderedLT')" :style="(readonly ? '' : 'cursor:pointer')">
                                        <p class="py-0 my-1">1. Acuity caveat invoked (constraints are imposed on the provider by</p>
                                        <p class="py-0 my-1">the urgency of the patient’s clinical condition and/or mental</p>
                                        <p class="py-0 my-1">status).</p>
                                        <p class="py-0 my-1">2. Psychiatric patient with any of the following:</p>
                                        <p class="py-0 my-1">Involuntary admissions</p>
                                        <p class="py-0 my-1">Voluntary admissions with three (3) or > ancillary studies or</p>
                                        <p class="py-0 my-1">any IV/IM therapy</p>
                                        <p class="py-0 my-1">Chemical or physical restraints</p>
                                        <p class="py-0 my-1">Observation for overdose.</p>
                                        <p class="py-0 my-1">Transfer to a psych facility.</p>
                                        <p class="py-0 my-1">3. One (1) IV or IM of Haldol™ or Ativan™ for agitation (not anxiety</p>
                                        <p class="py-0 my-1">alone)</p>
                                        <p class="py-0 my-1">4. Chest pain with cardiac workup including EKG and additional lab</p>
                                        <p class="py-0 my-1">studies plus cardiac enzymes (i.e. CPK and Troponin). CXR may or</p>
                                        <p class="py-0 my-1">may not be included.</p>
                                        <p class="py-0 my-1">5. Chest or abdominal pain and/or shortness of breath with three (3)</p>
                                        <p class="py-0 my-1">of the following:</p>
                                        <p class="py-0 my-1">Ancillary studies (three (3) or >)</p>
                                        <p class="py-0 my-1">Any IV or IM meds</p>
                                        <p class="py-0 my-1">IV fluids</p>
                                        <p class="py-0 my-1">Special Study</p>
                                        <p class="py-0 my-1">Two (2) or > Nebulizer breathing treatments.</p>
                                        <p class="py-0 my-1">6. Rape exam, any exam that requires forensic evidence or arranging</p>
                                        <p class="py-0 my-1">transfer to a rape crisis center.</p>
                                        <p class="py-0 my-1">7. Child or elder abuse or neglect case.</p>
                                        <p class="py-0 my-1">8. CPR performed during ED visit.</p>
                                    </v-col>
                                    <v-col :cols="(qaEnc ? 1 : 2)" :class="'text-center ' + (proMode ? 'checkBoxBorderedDK' : 'checkBoxBorderedLT')">
                                        <v-checkbox @change="calculateMDM" 
                                            style="height: 20px; margin-top: 8px;"
                                            label="High"
                                            v-model="mdmVal.worksheet.mdm.table_c.high"
                                        ></v-checkbox>
                                    </v-col>
                                    <v-col v-if="qaEnc" cols="1" :class="'text-center ' + (mdmVal.worksheet.mdm.table_c.high != mdmQaVal.worksheet.mdm.table_c.high ? 'red ' : '') + (proMode ? 'checkBoxBorderedDK' : 'checkBoxBorderedLT')">
                                        <v-checkbox @change="calculateMDM" 
                                            style="height: 20px; margin-top: 8px;"
                                            label="High"
                                            v-model="mdmQaVal.worksheet.mdm.table_c.high"
                                        ></v-checkbox>
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                    </v-expansion-panel-content>
                </v-expansion-panel>
            </v-expansion-panels>
        </v-row>
        <v-row class="px-0">
            <v-btn 
                :color="proMode ?  'grey darken-1' : 'grey-darken-4'"
                :background-color = "(proMode ? 'rgba(255, 255, 255, 0.06)':'rgba(0, 0, 0, 0.06)')" 
                icon
                block
                outlined
                style="max-width:100%;border-radius:0;height:20px"
                @click="sectionsExpand = !sectionsExpand"
            >
                <v-icon v-if="sectionsExpand">mdi-chevron-double-up</v-icon>
                <v-icon v-else>mdi-chevron-double-down</v-icon>
            </v-btn>
        </v-row>
        <!-- <v-row class="px-1">
            <v-expansion-panels 
                :style="'border:solid 1px ' + (proMode ? 'rgba(255, 255, 255, 0.12)':'rgba(0, 0, 0, 0.12)')"
                :dark="proMode" 
                v-model="mdmSection" 
                multiple 
                accordion
                tile
            >
                <v-expansion-panel
                    v-for="section in sections"
                    :key="section"
                >
                    <v-expansion-panel-header class="py-0" :color = "(proMode ? 'rgba(255, 255, 255, 0.08)':'rgba(0, 0, 0, 0.08)')" :style="'border-bottom:solid 1px ' + (proMode ? 'rgba(255, 255, 255, 0.12)':'rgba(0, 0, 0, 0.12)')">
                        {{section}}
                    </v-expansion-panel-header>
                    <v-expansion-panel-content class="px-0 mx-0 py-2">
                        <div v-if="section!='mdm'">
                            <div v-for="cbox in worksheetsettings.sections.main" :key="cbox.label" class="d-inline-flex pa-2">
                                <span v-if="cbox.type == 'checkbox'">
                                    <v-checkbox @change="calculateMDM" 
                                        v-model="checkedboxes[section]"
                                        :label="cbox.label"
                                        :value="cbox.label"
                                    ></v-checkbox>
                                </span>
                            </div>
                        </div>
                    </v-expansion-panel-content>
                </v-expansion-panel>
            </v-expansion-panels>
        </v-row>
        <v-row class="px-1">
            <v-btn 
                :color="proMode ?  'grey darken-1' : 'grey-darken-4'"
                :background-color = "(proMode ? 'rgba(255, 255, 255, 0.06)':'rgba(0, 0, 0, 0.06)')" 
                icon
                block
                outlined
                style="max-width:100%;border-radius:0;height:20px"
                @click="sectionsExpand = !sectionsExpand"
            >
                <v-icon v-if="sectionsExpand">mdi-chevron-double-up</v-icon>
                <v-icon v-else>mdi-chevron-double-down</v-icon>
            </v-btn>
        </v-row> -->
    </v-form>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
import { ulid } from 'ulid';

export default{
  name: 'MDMWKSHT',
    props: {
        mdmVal:{
            type:Object,
            required:true
        },
        mdmQaVal:{
            type:Object,
            required:false
        },
        emToolPro:{
            type:Object,
            required:false
        },
        mdmValid:{
            type:Boolean,
            required:false
        },
        qaEnc:{
            type:Boolean,
            required:false
        },
        readonly:{
            type:Boolean,
            required:false
        },
    },
    components: { 
        // RXAPI 
    },
    data() {
        return {
            mdmUp:0,
            showWorksheet:false,
            isLoading:false,
            mdmValidInt:false,
            mdmSection:[0],
            worksheetsettings: {},

            checkedboxes:{},

            codetabpro:{},
            sectionsExpand:false,

            checklistSection:[0],
            csectionsExpand:false,

            proworksheetexp:[],

            descriptionLimit: 50,
            entries: [],
            isLoading: false,
            model: null,
            searchAPI:null,

            menu1:[false],
            restab:"",
            difRes: false,

            sections:["History","Exam","MDM"],

            fieldRule: function(v,f){
                let out = true;
                // if(this.reqCheck(f) && !v){
                //     out = 'Field Required to QA/Complete';
                // }else{
                // }
                return [out];
            },
            fieldRuleDep: function(v,f,df){
                let out = true;
                if(df && this.reqCheck(f) && !v){
                    //out = 'Field Required to QA/Complete';
                    out='';
                }else{
                }
                return [out];
            },
            fieldRuleInd: function(v,f,ind){
                // let fArr = f.split("_"),
                //     fComb = fArr[0] + "_" + ind + "_" + fArr[1];
                let out = true;
                // if(this.reqCheck(fComb) && !v.code){
                //     out = 'Field Required to QA/Complete';
                // }else{
                // }
                return [out];
            },
        };
    },
    computed:{
        ...mapGetters(["facility","facSettings","noCalc","proMode","emToolProLT","departments"]),
        items () {
            return this.entries.map(entry => {
            const Description = entry.code + " - " + (entry.name.length > this.descriptionLimit
                ? entry.name.slice(0, this.descriptionLimit) + '...'
                : entry.name)

            return Object.assign({}, entry, { Description })
            })
        },
    },
    watch:{
    //   mdmVal:{
    //       handler: function(enc){
    //         //// console.log("AE CHANGE");
    //         this.mdmChanged();
    //         this.mdmUp++;
    //       },
    //       deep:true
    //   },
      mdmValidInt(val){
          this.$emit('validChanged', val);
      },
      sectionsExpand(exp){
          if(exp){
              // console.log("EXPAND!")
              let secsout = [];
              for(let d=0; d<this.sections.length; d++){
                  secsout.push(d);
              }
              // console.log(JSON.stringify(secsout));
              this.proworksheetexp = secsout;
          }else{
              // console.log("UNEXPAND")
              this.proworksheetexp = [];
          }
      },
    },
    mounted: function(){
        if(!this.mdmVal.worksheet){
            this.mdmVal.worksheet = {
                "exam": {
                    "cardiovascular": false,
                    "constitutional": false,
                    "endocrine": false,
                    "ent": false,
                    "eyes": false,
                    "gi": false,
                    "gu": false,
                    "hematologic_lymphatic": false,
                    "integumentary": false,
                    "musculoskeletal": false,
                    "neurologic": false,
                    "psychiatric": false,
                    "respiratory": false
                },
                "general": {
                    "shared_visit": false,
                    "teaching": false
                },
                "history": {
                    "hpi": {
                        "associated_signs_and_symptoms": false,
                        "context": false,
                        "duration": false,
                        "location": false,
                        "modifying_factors": false,
                        "quality": false,
                        "severity": false,
                        "timing": false
                    },
                    "pfshx": {
                        "family_history": false,
                        "past_medical": false,
                        "social_history": false
                    },
                    "ros": {
                        "all_other_systems_negative": false,
                        "allergic_immunologic": false,
                        "cardiovascular": false,
                        "constitutional": false,
                        "ed_caveat": false,
                        "endocrine": false,
                        "ent": false,
                        "eyes": false,
                        "gi": false,
                        "gu": false,
                        "hematologic_lymphatic": false,
                        "integumentary": false,
                        "musculoskeletal": false,
                        "neurologic": false,
                        "psychiatric": false,
                        "respiratory": false
                    }
                },
                "mdm": {
                    "table_a": {
                        "new_problem_no_additional_workup": false,
                        "new_problem_workup_planned": false
                    },
                    "table_b": {
                        "decision_to_obtain_old_records_history_from_someone_other_than_patient": false,
                        "discussion_of_test_results_with_performing_physician": false,
                        "independent_visualization_of_image_tracing_or_specimen_itself": false,
                        "review_and_summarization_of_old_records_obtaining_history_from_someone_other_than_patient_discussion_of_case_with_another_healthcare_provider": false,
                        "review_order_of_clinical_lab_test": false,
                        "review_order_of_test_in_the_medicine_section_of_cpt": false,
                        "review_order_of_test_in_the_radiology_section_of_cpt": false
                    },
                    "table_c": {
                        "high": false,
                        "high_moderate": false,
                        "low": false,
                        "low_moderate": false,
                        "minimal": false
                    }
                },
                "time": ""
            }
            this.showWorksheet = true;
        }else{
            this.showWorksheet = true;
        }
        this.getData(
            "https://vzw8xog2f7.execute-api.us-east-1.amazonaws.com/v2/worksheet/" + this.facility + "/mdm"
        ).then((response) => {
            this.worksheetsettings = response;
            this.mdmUp++;
        });
        this.mdmUp++;
    },
    // beforeMount: function() {
    //     
    // },
    methods: {
        mdmChanged(){
            // console.log("MDM FORM CHANGE");
            this.calculateMDM();
        },
        calculateMDM(){
            if(!this.noCalc){
                // console.log("CALCULATING WORKSHEET");
                this.emToolPro.time = this.mdmVal.worksheet.general.time;
                // console.log("TIME: " + this.emToolPro.time);

                let hpiCount = Object.values(this.mdmVal.worksheet.history.hpi).reduce((a, item) => a + item, 0),
                    hpiScore = (hpiCount > 3 ? 4 : 2),
                    rosCount = (this.mdmVal.worksheet.history.ros.all_other_systems_negative ? 10 : Object.values(this.mdmVal.worksheet.history.ros).reduce((a, item) => a + item, 0)),
                    rosScore = (rosCount>9 ? 4 : (rosCount>1 ? 3 : (rosCount==1 ? 2 : 1))),
                    pfshxCount = Object.values(this.mdmVal.worksheet.history.pfshx).reduce((a, item) => a + item, 0),
                    pfshxScore = (pfshxCount>1 ? 4 : (pfshxCount==0 ? 2 : 3)),
                    historyScore = 0,
                    examCount = Object.values(this.mdmVal.worksheet.exam).reduce((a, item) => a + item, 0),
                    examScore = (examCount>7 ? 4 : (examCount>4 ? 3 : (examCount>1 ? 2 : 1))),
                    //mdmaCount = Object.values(this.mdmVal.worksheet.mdm.table_a).reduce((a, item) => a + item, 0),
                    mdmaCount = 0,
                    mdmaTotal = mdmaCount,
                    mdmaScore = 0,
                    //mdmbCount = Object.values(this.mdmVal.worksheet.mdm.table_b).reduce((a, item) => a + item, 0),
                    mdmbCount = 0,
                    mdmbTotal = mdmbCount,
                    mdmbScore = 0,
                    //mdmcCount = Object.values(this.mdmVal.worksheet.mdm.table_c).reduce((a, item) => a + item, 0),
                    mdmcCount = 0,
                    mdmcScoreArr = [], mdmcScore = 0, mdmScore = 0;

                // console.log("HISTORY COUNT: HPI-" + hpiCount + " | ROS-" + rosCount + " | PFSHX-" + pfshxCount);
                if(hpiScore<3 && rosScore<3){
                    hpiScore=rosScore;
                }else if(hpiScore>2 && rosScore>2){
                    hpiScore=rosScore;
                }
                if(pfshxScore<3 && rosScore<3){
                    pfshxScore=rosScore;
                }
                if(hpiScore==rosScore && rosScore==pfshxScore && pfshxScore==rosScore){
                    historyScore = rosScore;
                }else{
                    let historyArr = [hpiScore,rosScore,pfshxScore];
                    historyScore = Math.min( ...historyArr );
                }
                // console.log("HISTORY SCORE: " + historyScore);
                this.emToolPro.history = this.emToolProLT.history[historyScore];
                // console.log("HISTORY: " + this.emToolPro.history);

                // console.log("EXAM COUNT: " + examCount);
                // console.log("EXAM SCORE: " + examScore);
                this.emToolPro.exam = this.emToolProLT.exam[examScore];
                // console.log("EXAM: " + this.emToolPro.exam);

                const mdmrub = {
                    "table_a": {
                        "new_problem_no_additional_workup": 3,
                        "new_problem_workup_planned": 4
                    },
                    "table_b": {
                        "decision_to_obtain_old_records_history_from_someone_other_than_patient": 1,
                        "discussion_of_test_results_with_performing_physician": 1,
                        "independent_visualization_of_image_tracing_or_specimen_itself": 2,
                        "review_and_summarization_of_old_records_obtaining_history_from_someone_other_than_patient_discussion_of_case_with_another_healthcare_provider": 2,
                        "review_order_of_clinical_lab_test": 1,
                        "review_order_of_test_in_the_medicine_section_of_cpt": 1,
                        "review_order_of_test_in_the_radiology_section_of_cpt": 1
                    },
                    "table_c": {
                        "high": 5,
                        "high_moderate": 4,
                        "low": 2,
                        "low_moderate": 3,
                        "minimal": 1
                    }
                };
                
                if(mdmcCount >= 0){
                    let mdmcKeys = Object.keys(this.mdmVal.worksheet.mdm.table_c);
                    for (let c=0; c<mdmcKeys.length; c++){
                        if(this.mdmVal.worksheet.mdm.table_c[mdmcKeys[c]]){
                            mdmcScoreArr.push(mdmrub.table_c[mdmcKeys[c]]);
                        }
                    }
                }
                mdmcScore = Math.max( ...mdmcScoreArr );
                if(mdmaCount >= 0){
                    let mdmaKeys = Object.keys(this.mdmVal.worksheet.mdm.table_a);
                    for (let a=0; a<mdmaKeys.length; a++){
                        if(this.mdmVal.worksheet.mdm.table_a[mdmaKeys[a]]){
                            mdmaTotal += mdmrub.table_a[mdmaKeys[a]];
                        }
                    }
                    mdmaScore = (mdmaTotal>3 ? 5 : (mdmaTotal<2 ? 1 : (mdmcScore==3 || mdmcScore==4 ? mdmcScore : mdmaTotal)));
                }
                if(mdmbCount >= 0){
                    let mdmbKeys = Object.keys(this.mdmVal.worksheet.mdm.table_b);
                    for (let b=0; b<mdmbKeys.length; b++){
                        if(this.mdmVal.worksheet.mdm.table_b[mdmbKeys[b]]){
                            mdmbTotal += mdmrub.table_b[mdmbKeys[b]];
                        }
                    }
                    mdmbScore = (mdmbTotal>3 ? 5 : (mdmbTotal<1 ? 1 : (mdmcScore==3 || mdmcScore==4 ? mdmcScore : mdmbTotal)));
                }
                // console.log("MDM TOTALS: A-" + mdmaTotal + " | B-" + mdmbTotal + " | C-" + JSON.stringify(mdmcScoreArr));
                // console.log("MDM SCORES: A-" + mdmaScore + " | B-" + mdmbScore + " | C-" + mdmcScore);
                if(mdmaScore==mdmbScore && mdmbScore==mdmcScore && mdmaScore==mdmcScore){
                    mdmScore = mdmcScore;
                }else{
                    let mdmArr = [mdmaScore,mdmbScore,mdmcScore],
                        mdmCount = mdmArr => mdmArr.reduce((prev, curr) => (prev[curr] = ++prev[curr] || 1, prev), {}),
                        mdmKeys = Object.keys(mdmCount);
                    // console.log("MDM COUNT: " + JSON.stringify(mdmCount));
                    for(let m=0; m<mdmKeys.length; m++){
                        if(mdmCount[mdmKeys[m]]>1){
                            mdmScore = mdmKeys[m];
                        }
                    }
                    if(!mdmScore){
                        mdmScore = this.median(mdmArr);
                    }
                }
                // console.log("MDM SCORE: " + mdmScore);
                this.emToolPro.mdm = this.emToolProLT.mdm[mdmScore];
                // console.log("MDM: " + this.emToolPro.mdm);

                this.$emit('worksheet-updated', this.emToolPro);
                this.mdmUp++;
            }else{
                this.emToolPro.time = this.mdmVal.worksheet.general.time;
                // console.log("TIME: " + this.emToolPro.time);
                this.$emit('worksheet-updated', this.emToolPro);
                this.mdmUp++;
            }
        },
        median(numbers) {
            const sorted = numbers.slice().sort((a, b) => a - b);
            const middle = Math.floor(sorted.length / 2);

            if (sorted.length % 2 === 0) {
                return (sorted[middle - 1] + sorted[middle]) / 2;
            }

            return sorted[middle];
        },
        modStringer(mods){
            let out = "";
            for(let m=0; m<mods.length; m++){
                out += mods[m] + (mods.length != m+1 ? ", " : "");
            }
            return out;
        },
        validateform(){
            this.validate();
        },
        reqCheck(field){
            let out = false;
            if(this.$store.getters.requiredFields.indexOf(field)>=0){
                out = true;
            }
            //// console.log("REQ CHECK: " + field + ": " + out);
            return out;
        },
        formatTime(inp){
            //// console.log(inp); // "([01]?[0-9]|2[0-3]):[0-5][0-9]"
            let out = "00:00";

            return inp;
        },
        dtConvert(dos,time,type,nd){
            //// console.log(dos + " | " + time + " | " + type + " | " + nd);
            let out = null,preout;
            if(type == "stop" && time && nd){
                let d = new Date(dos + " " + "12:00"),
                        dp = new Date(d.getTime() + 86400000),
                        dateplus = dp.toISOString().split("T")[0];
                // // console.log(d);
                // // console.log(dp);
                // // console.log(dateplus);
                preout = new Date(dateplus + " " + time);
                out = preout.getTime();
            }else if(time){
                preout = new Date(dos + " " + time);
                out = preout.getTime();
            }
            return out;
        },
        allCapArray(arr){
            //// console.log("IN: " + JSON.stringify(arr));
            for(let a=0; a<arr.length; a++){
                arr[a] = arr[a].toString().toUpperCase().replace(/\s+/g, '');
                let ind = arr.indexOf(arr[a]);
                //// console.log("IND: " + ind);
                //// console.log("A: " + a);
                if(ind != -1 && ind != a){
                    //arr.splice(a,1);
                    arr.splice(ind,1);
                }
            }
            let out = [...new Set(arr)]
            //// console.log("OUT: " + JSON.stringify(out));
            return out;
        },
        forceFormValidate(form){
            //// console.log("FORCE VALIDATE: " + form);
            this.$refs[form].validate();
        },
        getProviderDetail:function(uuid){
            if(uuid){
                let provDet = this.$store.getters.Providers.find(x => x.uuid == uuid),out="";
                // console.log(JSON.stringify(provDet));
                //// console.log(provDet.displayName + " (" + uuid + ")");
                if(provDet){
                    if(provDet.displayName){
                        out = provDet.displayName + " (" + uuid + ")"
                    }else{
                        out = uuid;
                    }
                }else{
                    out = uuid;
                }
                return out;
            }else{
                return "";
            }
        },
        async postData(url = "", data = {}) {
        const session = await this.$Amplify.Auth.currentSession();
  const iT = session.getIdToken();
  const jwt = iT.getJwtToken();
            // Default options are marked with *
            const response = await fetch(url, {
            method: "POST", // *GET, POST, PUT, DELETE, etc.
            mode: "cors", // no-cors, *cors, same-origin
            cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
            headers: {
                "Content-Type": "application/json",
                "Authorization": jwt
            },
            //redirect: 'follow', // manual, *follow, error
            //referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
            body: JSON.stringify(data), // body data type must match "Content-Type" header
            });
            return response.json(); // parses JSON response into native JavaScript objects
        },
        async getData(url = "") {
            const session = await this.$Amplify.Auth.currentSession();
  const iT = session.getIdToken();
  const jwt = iT.getJwtToken();
            // Default options are marked with *
            const response = await fetch(url, {
            method: "GET", // *GET, POST, PUT, DELETE, etc.
            mode: "cors", // no-cors, *cors, same-origin
            cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
            headers: {
                "Content-Type": "application/json",
                "Authorization": jwt
            },
            //redirect: 'follow', // manual, *follow, error
            //referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
            });
            return response.json(); // parses JSON response into native JavaScript objects
        },
        calcAge(){
            //// console.log("CALC AGE");
            this.menudob = false;
        },
        ageTator(dobin){
            //// console.log("DOB IN: " + dobin);
            let out;
            if(dobin && dobin.includes("/")){
                let dobarr = dobin.split("/"),
                    dob = new Date(dobarr[2],dobarr[0],dobarr[1]),
                    diff = Date.now() - dob.getTime(),
                    age = new Date(diff);
                out = Math.abs(age.getUTCFullYear() - 1970);
            }else if(dobin && dobin.includes("-")){
                let dobarr = dobin.split("-"),
                    dob = new Date(dobarr[0],dobarr[1],dobarr[2]),
                    diff = Date.now() - dob.getTime(),
                    age = new Date(diff);
                out = Math.abs(age.getUTCFullYear() - 1970);
            }else{
                out = null;
            }
            return out
        }
    }
  };
</script>

<style>
    .nextDay label{
        font-size: 14px;
        line-height: 14px !important;
        margin-left: -5px;
    }
    .theme--dark.v-tabs-items{
        background-color: unset;
    }
    .checkBoxBorderedDK{
        border:thin solid rgba(255, 255, 255, 0.35);
    }

    .checkBoxBorderedLT{
        border:thin solid rgba(0, 0, 0, 0.35);
    }

    .tallField .v-input__slot{
        height: 50px !important;
    }

    .v-input__slot {
    align-items: center;
    justify-content: center;
    }
</style>